<!--设备管理-->
<template>
  <customSidebar>
    <div>
      <div class="device-content">
        <a-menu v-hasPermi="['devices:aircraft','devices:dock']" v-model:selectedKeys="current" mode="horizontal" @select="select">
          <a-menu-item v-hasPermi="['devices:dock']" :key="EDeviceTypeName.Dock">
            机场
          </a-menu-item>
          <a-menu-item v-hasPermi="['devices:aircraft']" :key="EDeviceTypeName.Aircraft" class="ml20">
            无人机
          </a-menu-item>
        </a-menu>
      </div>
      <div>
        <div class="device-table-wrap table">
          <a-button class="mb10" v-if="current.includes(EDeviceTypeName.Dock)" @click="openDeviceCode" >设备绑定码</a-button>
          <a-table :columns="columns" :data-source="data.device" :pagination="paginationProp" @change="refreshData"
            row-key="device_sn" :expandedRowKeys="expandRows" :row-selection="rowSelection" :rowClassName="rowClassName"
            :scroll="{ x: '100%', y: 600 }" :expandIcon="expandIcon" :loading="loading">
            <template #bodyCell="{ column, record }">
              <template v-if="column.key === 'device_sn'">
                <span :title="record.device_sn">{{ formatDeviceSn(record.device_sn) }}</span>
              </template>
              <template v-if="column.key === 'firmware_version'">
                <span v-if="judgeCurrentType(EDeviceTypeName.Dock)">
                  <DeviceFirmwareUpgrade :device="record" class="table-flex-col" @device-upgrade="onDeviceUpgrade" />
                </span>
                <span v-else>
                  {{ record.firmware_version }}
                </span>
              </template>
              <template v-if="column.key === 'status'">
                <span v-if="record.status" class="flex-row flex-align-center">
                  <span class="mr5" style="width: 12px; height: 12px; border-radius: 50%; background-color: green;" />
                  <span>在线</span>
                </span>
                <span class="flex-row flex-align-center" v-else>
                  <span class="mr5" style="width: 12px; height: 12px; border-radius: 50%; background-color: red;" />
                  <span>离线</span>
                </span>
              </template>
              <template v-if="column.key === 'use_status'">
                <span v-if="record.use_status === 0" class="flex-row flex-align-center">
                  <span class="mr5" style="width: 12px; height: 12px; border-radius: 50%; background-color: green;" />
                  <span>启用</span>
                </span>
                <span class="flex-row flex-align-center" v-else>
                  <span class="mr5" style="width: 12px; height: 12px; border-radius: 50%; background-color: red;" />
                  <span>停用</span>
                </span>
              </template>
              <template v-if="column.key === 'manufacturer'">{{ record.manufacturer || '--' }}</template>
              <template v-if="column.key === 'actions'">
                <div class="editable-row-operations">
                  <div v-hasPermi="['devices:edit']" v-if="editableData[record.device_sn]">
                    <a-tooltip title="确认更改">
                      <span @click="save(record)" style="color: #28d445;">
                        <CheckOutlined />
                      </span>
                    </a-tooltip>
                    <a-tooltip title="取消修改">
                      <span @click="() => delete editableData[record.device_sn]" style="color: #e70102;">
                        <CloseOutlined />
                      </span>
                    </a-tooltip>
                  </div>
                  <!-- 非编辑态操作 -->
                  <div v-else class="flex-align-center flex-row" style="color: #2d8cf0">
                    <template v-if="judgeCurrentType(EDeviceTypeName.Dock) && record.domain === EDeviceTypeName.Dock">
                      <!-- 主行操作 -->
                      <a-dropdown v-hasPermi="['devices:pane']">
                        <template #overlay>
                          <a-menu>
                            <a-menu-item v-hasPermi="['devices:paneV1']">
                              <span @click="openFlyControlPanel(record,'v1')">驾驶舱</span>
                            </a-menu-item>
                            <a-menu-item v-hasPermi="['devices:paneV2']">
                              <span @click="openFlyControlPanel(record,'v2')">驾驶舱</span>
                            </a-menu-item>
                          </a-menu>
                        </template>
                      </a-dropdown>
                      <a-tooltip title="驾驶舱" v-hasPermi="['devices:pane']">
                        <SvgIcon name="steering-wheel" class="cur-p" @click="openChosePanel(record)"/>
                      </a-tooltip>

                      <a-tooltip title="设备日志" v-hasPermi="['devices:log']">
                        <CloudServerOutlined @click="showDeviceLogUploadRecord(record)" class="ml10"/>
                      </a-tooltip>
                      <a-tooltip title="Hms信息" v-hasPermi="['devices:hms']">
                        <FileSearchOutlined @click="showHms(record)" />
                      </a-tooltip>
                      <a-tooltip title="编辑" v-hasPermi="['devices:edit']">
                        <EditOutlined @click="edit(record)" />
                      </a-tooltip>
                      <a-tooltip title="配置" v-hasPermi="['devices:settings']">
                        <SettingTwoTone @click="openSettingDrawer(record)" />
                      </a-tooltip>
                      <a-dropdown v-hasPermi="['devices:view','devices:alarm:list','devices:device']">
                        <a @click.prevent>
                          <EllipsisOutlined />
                        </a>
                        <template #overlay>
                          <a-menu>
                            <a-menu-item v-hasPermi="['devices:view']">
                              <a-tooltip title="运维">
                                <SecurityScanTwoTone @click="showDevice(record)" style="font-size: 18px;" />
                              </a-tooltip>
                            </a-menu-item>
                            <a-menu-item v-hasPermi="['devices:alarm:list']">
                              <a-tooltip title="告警列表">
                                <AlertTwoTone @click="openDrawer(record)" style="font-size: 18px;" />
                              </a-tooltip>
                            </a-menu-item>
                            <a-menu-item v-hasPermi="['devices:device']">
                              <a-tooltip title="传感器预警">
                                <AlertTwoTone @click="openSensorDrawer(record)" style="font-size: 18px;" />
                              </a-tooltip>
                            </a-menu-item>
                          </a-menu>
                        </template>
                      </a-dropdown>
                      <a-tooltip v-hasPermi="['devices:status']" :title="record.use_status === 0 ? '设备停用' : '设备启用'">
                        <a class="fz18 ml8" @click="handleDeviceUseStatus(record, record.use_status === 0 ? 1 : 0, 'userStatus')">
                          <StopOutlined v-if="record.use_status === 0" class="fz14"/>
                          <CheckCircleOutlined v-else class="fz14"/>
                        </a>
                      </a-tooltip>
                      <a-tooltip v-hasPermi="['devices:bind']" title="解绑">
                        <DeleteOutlined @click="() => { deleteTip = true, deleteSn = record.device_sn }" class="ml5" />
                      </a-tooltip>
                    </template>

                    <!-- 当选择的是机场且当前行是无人机（展开行） -->
                    <template v-else-if="judgeCurrentType(EDeviceTypeName.Dock) && record.domain === EDeviceTypeName.Aircraft">
                      <!-- 展开行操作 -->
                      <a-tooltip v-hasPermi="['devices:hms']" title="Hms信息">
                        <FileSearchOutlined @click="showHms(record)" />
                      </a-tooltip>
                      <a-tooltip v-hasPermi="['devices:edit']" title="编辑">
                        <EditOutlined @click="edit(record)" />
                      </a-tooltip>
                      <a-tooltip v-hasPermi="['devices:settings']" title="配置">
                        <SettingTwoTone @click="openSettingDrawer(record)" />
                      </a-tooltip>
                    </template>

                    <!-- 当选择的是无人机（不变） -->
                    <template v-else>
                      <a-tooltip v-hasPermi="['devices:edit']" title="编辑">
                        <EditOutlined @click="edit(record)" />
                      </a-tooltip>
                      <a-tooltip v-hasPermi="['devices:bind']" title="解绑">
                        <DeleteOutlined @click="() => { deleteTip = true, deleteSn = record.device_sn }" class="ml5" />
                      </a-tooltip>
                    </template>
                  </div>
                </div>
              </template>
              <template v-else-if="column.key === 'nickname'">
    <div>
      <a-input
        v-if="editableData[record.device_sn]"
        v-model:value="editableData[record.device_sn].nickname"
        class="sn-input"
      />
      <template v-else>
        <a-tooltip :title="record.nickname">
          {{ record.nickname }}
        </a-tooltip>
      </template>
    </div>
  </template>

  <!-- workspace -->
  <template v-else-if="column.key === 'workspace'">
    <a-tooltip :title="record.workspace_name">
      <span>{{ record.workspace_name }}</span>
    </a-tooltip>
  </template>
            </template>

            <!-- <template v-for="col in ['nickname']" #[col]="{ text, record }" :key="col">
              <div>
                <a-input v-if="editableData[record.device_sn]" v-model:value="editableData[record.device_sn][col]"
                  class="sn-input" />
                <template v-else>
                  <a-tooltip :title="text">
                    {{ text }}
                  </a-tooltip>
                </template>
              </div>
            </template>
            <template v-for="col in ['sn', 'workspace']" #[col]="{ text }" :key="col">
              <a-tooltip :title="text">
                <span>{{ text }}</span>
              </a-tooltip>
            </template> -->
          </a-table>

          <a-modal v-model:visible="panelChoseVisible" :footer="null" :title="panelChoseName" @cancel="panelChoseVisible = false" centered :mask="false" width="27%">
            <div class="pilot-selector">
              <a-radio-group v-model:value="selectedPilotId" class="pilot-radio-group">
                <a-radio-button v-for="item in pilotData" :key="item.user_id" :value="item.user_id">
                  {{ item.username }}
                </a-radio-button>
              </a-radio-group>
              <div class="button-group">
                <a-button type="primary" @click="openFlyControlPanel(currentDevices, 'v1')" >
                  驾驶舱v1
                </a-button>
                <a-button type="primary" @click="openFlyControlPanel(currentDevices, 'v2')" class="ml20">
                  驾驶舱v2
                </a-button>
              </div>
            </div>
          </a-modal>

          <a-modal v-model:visible="deleteTip" width="450px" :closable="false" centered
            :okButtonProps="{ danger: true }" @ok="unbind">
            <p class="pt10 pl20" style="height: 50px;">是否解绑当前设备？</p>
            <template #title>
              <div class="flex-row flex-justify-center">
                <span>设备解绑</span>
              </div>
            </template>
          </a-modal>

          <!-- 设备升级 -->
          <DeviceFirmwareUpgradeModal title="设备升级" v-model:visible="deviceFirmwareUpgradeModalVisible"
            :device="selectedDevice" @ok="onUpgradeDeviceOk"></DeviceFirmwareUpgradeModal>

          <!-- 设备日志上传记录 -->
          <DeviceLogUploadRecordDrawer v-model:visible="deviceLogUploadRecordVisible" :device="currentDevice">
          </DeviceLogUploadRecordDrawer>

          <!-- hms 信息 -->
          <DeviceHmsDrawer v-model:visible="hmsVisible" :device="currentDevice">
          </DeviceHmsDrawer>
        </div>
      </div>
    </div>

    <a-modal v-model:visible="deviceCodeVisible" title="设备绑定码" :footer="null" @cancel="deviceCodeVisible = false" centered>
      <div class="bind-code-content">
        <div class="bind-info-row">
          <div class="bind-label">mqtt连接信息：</div>
          <div class="bind-value">{{ codeMessage.mqtt_broker }}</div>
        </div>
        <div class="bind-info-row">
          <div class="bind-label">mqtt连接用户：</div>
          <div class="bind-value">{{ codeMessage.username }}</div>
        </div>
        <div class="bind-info-row">
          <div class="bind-label">mqtt连接密码：</div>
          <div class="bind-value">{{ codeMessage.password }}</div>
        </div>
        <div class="bind-info-row">
          <div class="bind-label">绑定码：</div>
          <div class="bind-value bind-code">{{ codeMessage.bind_code }}</div>
        </div>
      </div>
    </a-modal>

    <!--告警列表-->
    <a-drawer placement="right" :visible="drawerVisible" @close="drawerVisible = false" class="algo-drawer"
      :width="'50%'" :maskStyle="{ backgroundColor: 'rgba(255, 255, 255, 0.09)' }">
      <template #title>
        <p class="ala-drawer-title">告警信息</p>
      </template>
      <div class="mt20 mb10">
        <a-select v-model:value="alarmLevel" @change="fetchData(true)" placeholder="告警等级" class="ala-select">
          <a-select-option value="1">一级</a-select-option>
          <a-select-option value="2">二级</a-select-option>
          <a-select-option value="3">三级</a-select-option>
        </a-select>
        <a-range-picker v-model:value="dataTime" @change="fetchData(true)"/>
        <a-button type="primary" style="margin-left: 15px; border-radius: 4px;" @click="fetchData(true)"><SearchOutlined />查询</a-button>
        <a-button type="primary" style="margin-left: 15px; border-radius: 4px;" @click="resetSearch"><SyncOutlined />重置</a-button>
      </div>
      <div>
        <a-table :columns="columns1" :data-source="alaData" :pagination="alarmPaginationProp" row-key="id" class="org-table"
          :bordered="false" :row-class-name="rowZibreClassName" @change="handleTableChange" :scroll="{ x: '100%', y: 600 }">
          <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'alarm_level'">
              <a-tag :color="alarmLevelConfig[record.alarm_level]?.color || 'gray'">
                {{ alarmLevelConfig[record.alarm_level]?.text || '未知' }}
              </a-tag>
            </template>
          </template>
        </a-table>
      </div>
    </a-drawer>

    <!--预警列表-->
    <a-drawer placement="right" :visible="sensorVisible" @close="sensorVisible = false" class="algo-drawer"
      :width="'50%'" :maskStyle="{ backgroundColor: 'rgba(255, 255, 255, 0.09)' }">
      <template #title>
        <p class="ala-drawer-title">传感器预警</p>
      </template>
      <div class="mt20 mb10">
        <a-date-picker v-model:value="selectedDate" @change="fetchSensorData(true)" placeholder="选择日期"/>
        <a-button type="primary" style="margin-left: 15px; border-radius: 4px;" @click="fetchSensorData(true)"><SearchOutlined />查询</a-button>
        <a-button type="primary" style="margin-left: 15px; border-radius: 4px; " @click="resetSensorSearch"><SyncOutlined />重置</a-button>
      </div>
      <div v-if="sensorLoading" class="loading-container">
        <div class="loading-spinner">
          <a-spin size="large" />
          <div class="loading-text">数据加载中...</div>
        </div>
      </div>
      <div v-else>
        <a-table :columns="sensorColumns" :data-source="sensorData" :pagination="sensorPaginationProp" row-key="id" class="org-table"
          :bordered="false" @change="handleSensorChange" :scroll="{ x: '100%', y: 600 }">
          <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'action'">
              <span class="clickable-message" @click="messageDetail(record)">详情</span>
            </template>
          </template>
        </a-table>
      </div>
    </a-drawer>

    <a-modal v-model:visible="sensorMessageVisible" title="传感器预警详情" :width="'1000px'" :footer="null" class="sensor-message-modal" @cancel="handleCloseDetail">
      <div v-if="currentRecord" class="detail-content">
        <!-- 基本信息卡片 -->
        <a-card class="detail-card">
          <template #title>
            <div class="card-header">
              <InfoCircleOutlined />
              <span class="ml8">基本信息</span>
            </div>
          </template>
          <a-descriptions :column="2" bordered size="small">
            <a-descriptions-item label="记录ID">
              <a-tag size="small" color="blue">{{ currentRecord.id }}</a-tag>
            </a-descriptions-item>
            <a-descriptions-item label="消息主题">
              <span>{{ currentRecord.topic || '-' }}</span>
            </a-descriptions-item>
            <a-descriptions-item label="方法">
              <a-tag v-if="currentRecord.method" size="small" color="purple">{{ currentRecord.method }}</a-tag>
              <span v-else>-</span>
            </a-descriptions-item>
            <a-descriptions-item label="消息时间">
              <ClockCircleOutlined style="margin-right: 5px;" />
              <span>{{ currentRecord.deliveryTime ? parseTime(currentRecord.deliveryTime, '{y}-{m}-{d} {h}:{i}:{s}') : '-' }}</span>
            </a-descriptions-item>
          </a-descriptions>
        </a-card>

        <!-- 设备信息卡片 -->
        <a-card class="detail-card" v-if="currentRecord.deviceSn || currentRecord.deviceName">
          <template #title>
            <div class="card-header">
              <DesktopOutlined />
              <span class="ml8">设备信息</span>
            </div>
          </template>
          <a-descriptions :column="2" bordered size="small">
            <a-descriptions-item label="设备SN">
              <span class="device-info" :title="currentRecord.deviceSn">{{ formatDeviceSn(currentRecord.deviceSn) || '-' }}</span>
            </a-descriptions-item>
            <a-descriptions-item label="设备名称">
              <span class="device-info">{{ currentRecord.deviceName || '-' }}</span>
            </a-descriptions-item>
          </a-descriptions>
        </a-card>

        <!-- MQTT消息卡片 -->
        <a-card class="detail-card">
          <template #title>
            <div class="card-header">
              <FileTextOutlined />
              <span class="ml8">MQTT消息内容</span>
              <div class="action-buttons">
                <a-button
                  v-if="parsedMessage"
                  type="text"
                  size="small"
                  @click="showRawJson = !showRawJson"
                  class="toggle-btn"
                >
                  <SwapOutlined />
                  {{ showRawJson ? '结构化视图' : '原始JSON' }}
                </a-button>
                <a-button
                  type="text"
                  size="small"
                  @click="copyMessage(currentRecord.message)"
                  class="copy-btn"
                >
                  <CopyOutlined />
                  复制
                </a-button>
              </div>
            </div>
          </template>

          <div class="message-content">
            <!-- 结构化视图 -->
            <div v-if="currentRecord.message && parsedMessage && !showRawJson">
              <div v-if="parsedMessage.data && Array.isArray(parsedMessage.data) && parsedMessage.data.length > 0" class="aircraft-data-section">
                <div class="data-info">
                  <span class="data-count">共 {{ parsedMessage.data.length }} 条飞行器数据</span>
                </div>
                <a-table
                  :columns="sensorMessageColumns"
                  :data-source="parsedMessage.data"
                  :pagination="false"
                  :scroll="{ x: 'max-content', y: 300 }"
                  size="small"
                  class="message-table"
                  row-key="icao"
                >
                  <template #bodyCell="{ column, record }">
                    <template v-if="column.key === 'index'"><span class="row-index">{{ index + 1 }}</span></template>
                    <template v-if="column.key === 'warning_level'">
                      <a-tag :color="getWarningLevelColor(record.warning_level)" size="small">
                        {{ getWarningLevelText(record.warning_level) }}
                      </a-tag>
                    </template>
                    <template v-if="column.key === 'distance'">
                      <span v-if="record.distance">{{ record.distance.toLocaleString() }}m</span>
                      <span v-else>-</span>
                    </template>
                    <template v-if="column.key === 'altitude_type'">
                      {{ record.altitude_type === 0 ? '椭球高' : '海拔高' }}
                    </template>
                    <template v-if="column.key === 'altitude'">{{ record.altitude || '-' }}</template>
                    <template v-if="column.key === 'relative_altitude'">{{ record.relative_altitude || '-' }}</template>
                    <template v-if="column.key === 'heading'">
                      <span v-if="record.heading">{{ record.heading.toFixed(1) }}°</span>
                      <span v-else>-</span>
                    </template>
                    <template v-if="column.key === 'vert_trend'">
                      <a-tag :color="getVertTrendColor(record.vert_trend)" size="small">
                        {{ getVertTrendText(record.vert_trend) }}
                      </a-tag>
                    </template>
                    <template v-if="column.key === 'latitude'">
                      <span v-if="record.latitude">{{ record.latitude.toFixed(6) }}</span>
                      <span v-else>-</span>
                    </template>
                    <template v-if="column.key === 'longitude'">
                      <span v-if="record.longitude">{{ record.longitude.toFixed(6) }}</span>
                      <span v-else>-</span>
                    </template>
                  </template>
                </a-table>
              </div>
              <div v-else class="empty-data">
                <a-empty description="暂无结构化数据" />
              </div>
            </div>

            <!-- 原始JSON视图 -->
            <div v-else-if="currentRecord.message && showRawJson" class="json-section">
              <div class="json-content">
                <pre class="json-pretty">{{ formatJsonMessage(currentRecord.message) }}</pre>
              </div>
            </div>

            <!-- 解析错误视图 -->
            <div v-else-if="currentRecord.message && !parsedMessage && !showRawJson" class="parse-error">
              <a-alert
                message="无法解析JSON格式"
                type="warning"
                show-icon
                :closable="false"
              />
              <div class="raw-message">
                <pre>{{ currentRecord.message }}</pre>
              </div>
            </div>

            <!-- 空数据 -->
            <div v-else class="empty-message">
              <a-empty description="暂无消息内容" :image="simpleImage" />
            </div>
          </div>
        </a-card>
      </div>
    </a-modal>

    <!--预警详情
    <a-modal v-model:visible="sensorMessageVisible" title="传感器预警详情" :width="'800px'">
      <div>
        <a-tooltip title="复制" placement="top">
          <SnippetsOutlined @click="handleCopy" class="copy-icon"/>
        </a-tooltip>
      </div>
      <div class="json-container">
        <pre>{{ formattedJson }}</pre>
      </div>
      <template #footer>
        <a-button type="primary" @click="sensorMessageVisible = false">知道了</a-button>
      </template>
    </a-modal>-->

        <!--授权列表-->
    <a-drawer placement="right" :visible="settingDrawerVisible" @close="settingDrawerVisible = false" class="algo-drawer"
       :width="'50%'" :maskStyle="{ backgroundColor: 'rgba(255, 255, 255, 0.09)' }">
      <template #title>
        <p class="ala-drawer-title">机场授权信息</p>
      </template>
      <div style="margin-bottom: 20px;">
        <a-select ref="select" v-model:value="userDeviceRelationWorkspace" @change="fetchSettingData" class="ala-select" allowClear>
          <a-select-option v-for="item in userDeviceRelationWorkspaceDataList" :key="item.workspace_id" :value="item.workspace_id">{{ item.workspace_name }}</a-select-option>
        </a-select>
        <a-select ref="select" v-model:value="authStatus" @change="fetchSettingData" class="ala-select" allowClear>
          <a-select-option v-for="item in authStatusDataList" :key="item.dict_value" :value="item.dict_value">{{ item.dict_label }}</a-select-option>
        </a-select>
        <a-input
          v-model:value="searchName"
          placeholder="请输入使用人名称"
          class="list-search"
          @pressEnter="fetchSettingData()"
          allow-clear
        />
        <a-button type="primary" style="margin-left: 15px; border-radius: 4px;" @click="resetSettingSearch"><SyncOutlined />重置</a-button>
        <a-button type="primary" style="margin-left: 15px; border-radius: 4px;" @click="showSettingModal = true"><PlusOutlined />添加授权</a-button>
      </div>
      <div>
        <a-table :columns="settingColumns" :data-source="settingData" :pagination="paginationProp" row-key="id" class="org-table"
          :bordered="false" :row-class-name="rowZibreClassName" >
          <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'action'">
              <a-space>
                <a-tooltip title="查看" placement="top">
                  <EyeTwoTone style="font-size: 20px; cursor:pointer;" @click="onViewSetting(record)" />
                </a-tooltip>
                <a-tooltip v-if="record.status != 'REMOVED'" title="删除" placement="top">
                  <DeleteTwoTone style="font-size: 20px;" @click="onDeleteSetting(record)" />
                </a-tooltip>
              </a-space>
            </template>
          </template>
        </a-table>
      </div>
    </a-drawer>
    <a-modal v-model:visible="showSettingModal" title="新增授权"
      width="600px" ok-text="确定" canca-text="取消" @ok="handleCreateSettingOk" @cancel="resetCreatSettingForm">
      <div style="display:flex;">
        <div style="flex:1;min-width:0;">
          <a-form :model="createForm" :laba-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-form-item label="设备名称" name="nickname">
              {{ device.nickname }}
            </a-form-item>
            <a-form-item label="设备型号" name="device_name">
              {{ device.device_name }}
            </a-form-item>
            <a-form-item label="使用人" name="user_names" required>
              <div style="display:flex;align-items:center;">
                <a-input v-model:value="createForm.user_names" placeholder="请选择使用" style="flex:1; width: 100px; padding-right: 30px;" readonly />
                <PlusCircleTwoTone style="font-size: 20px; margin-left:10px; cursor:pointer;" @click="createUserPanel" />
              </div>
            </a-form-item>
            <a-form-item label="授权期限" name="term" required>
              <a-select v-model:value="createForm.term">
                <a-select-option v-for="item in authTermDataList" :key="item.dict_value" :value="item.dict_value">{{
                  item.dict_label }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item v-show="createForm.term === '1'" label="授权日期">
              <a-range-picker class="custom-date-picker"
                v-model:value="createForm.valid_date"
                :show-time="{ format: 'HH:mm:ss' }"
                format="YYYY-MM-DD HH:mm:ss"
                :placeholder="['起始时间','截止时间']"
              />
            </a-form-item>
            <a-form-item label="使用事由" name="reason">
              <a-textarea v-model:value="createForm.reason" />
            </a-form-item>
          </a-form>
        </div>
      </div>
      <template #footer>
        <a-button @click="resetCreatSettingForm">取消</a-button>
        <a-button type="primary" style="margin-left:10px;" @click="handleCreateSettingOk">确定</a-button>
      </template>
    </a-modal>
      <!-- 外部并排的添加人员面板 -->
    <div v-if="showUserPanel && showSettingModal" :style="userPanelStyle">
      <div style="font-weight:bold;font-size:16px;margin-bottom:16px;">添加人员</div>
      <a-checkbox-group v-model:value="selectedUserIds" style="width:100%;" @change="handleUserPanelChange">
        <a-row>
          <a-col :span="24" v-for="user in userList" :key="user.user_id">
            <a-checkbox :value="user.user_id">{{ user.username }}</a-checkbox>
          </a-col>
        </a-row>
      </a-checkbox-group>
      <!-- 取消按钮已移除，由加号按钮控制面板显示/隐藏 -->
    </div>
    <a-modal
      v-model:visible="showAuthDetailModal"
      @cancel="fetchSettingData"
      title="授权信息"
      width="850px"
      :footer="null"
      :bodyStyle="{ background: '#fff', borderRadius: '12px' }"
    >
      <div class="auth-detail-header">
        <div class="auth-detail-header-flex">
          <!-- 左侧：用户信息 -->
          <div class="auth-detail-user">
            <div class="auth-detail-user-info">
              <div class="auth-detail-field">
                <span class="auth-detail-label">姓名：</span>
                <span class="auth-detail-value">{{ authDetail.username }}</span>
              </div>
              <div class="auth-detail-field">
                <span class="auth-detail-label">所属部门：</span>
                <span class="auth-detail-value">{{ authDetail.workspace_name }}</span>
              </div>
            </div>
            <img :src="peopleIcon" class="auth-detail-user-icon" />
          </div>
          <!-- 中间：状态（上下结构，强制居中） -->
          <div class="auth-detail-status-center-vertical-force">
            <div
              class="auth-detail-status-green-text"
              :style="{ color: getStatusConfig(authDetail.status).color }"
            >
              {{ getStatusConfig(authDetail.status).label }}
            </div>
            <span class="auth-detail-status-link">
              <svg v-if="getStatusConfig(authDetail.status).chain === 'IN_EFFECT'" width="36" height="20" viewBox="0 0 32 18" style="vertical-align: middle;">
                <g fill="none" :stroke="getStatusConfig(authDetail.status).color" stroke-width="2">
                  <rect x="1" y="5" width="12" height="8" rx="4"/>
                  <rect x="19" y="5" width="12" height="8" rx="4"/>
                  <path d="M13 9h6"/>
                </g>
              </svg>
              <svg v-else-if="getStatusConfig(authDetail.status).chain === 'PENDING_EFFECTIVENESS'" width="36" height="20" viewBox="0 0 32 18" style="vertical-align: middle;">
                <g fill="none" :stroke="getStatusConfig(authDetail.status).color" stroke-width="2" stroke-dasharray="4,2">
                  <rect x="1" y="5" width="12" height="8" rx="4"/>
                  <rect x="19" y="5" width="12" height="8" rx="4"/>
                  <path d="M13 9h6"/>
                </g>
              </svg>
              <svg v-else width="36" height="20" viewBox="0 0 32 18" style="vertical-align: middle;">
                <g fill="none" :stroke="getStatusConfig(authDetail.status).color" stroke-width="2">
                  <rect x="1" y="5" width="12" height="8" rx="4"/>
                  <rect x="19" y="5" width="12" height="8" rx="4"/>
                  <!-- 断链：中间断开 -->
                  <path d="M13 9h2" />
                  <path d="M17 9h2" />
                </g>
              </svg>
            </span>
            <div class="auth-detail-status-time">{{ authDetail.valid_date }}</div>
          </div>
          <!-- 右侧：设备信息（图片和文字左右结构） -->
          <div class="auth-detail-device-horizontal">
            <img :src="dock3" class="auth-detail-device-icon" />
            <div class="auth-detail-device-info-vertical">
              <div class="auth-detail-field">
                <span class="auth-detail-label">设备名称：</span>
                <span class="auth-detail-value">{{ device.nickname }}</span>
              </div>
              <div class="auth-detail-field">
                <span class="auth-detail-label">设备型号：</span>
                <span class="auth-detail-value">{{ device.device_name }}</span>
              </div>
              <div class="auth-detail-field">
                <span class="auth-detail-label">设备SN：</span>
                <span class="auth-detail-value" :title="device.device_sn">{{ formatDeviceSn(device.device_sn) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="auth-detail-history">
        <div class="auth-detail-history-title">授权历史</div>
        <a-table
          :columns="authColumns"
          :data-source="authHistory"
          :pagination="false"
          row-key="id"
          :bordered="false"
          class="auth-detail-table"
          :scroll="{ x: 'max-content' }"
        >
          <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'action'">
              <a-space>
                <a-tooltip v-if="record.status != 'REMOVED'" title="移除" placement="top">
                  <DeleteTwoTone style="font-size: 20px; cursor:pointer;" @click="onDeleteSetting2(record)" />
                </a-tooltip>
              </a-space>
            </template>
          </template>
        </a-table>
      </div>
    </a-modal>
    <a-modal v-model:visible="modalVisible" :title="'设备运维'" width="66%" height="50%" :footer="null" style="top: 7%">
      <div>
        <div class="airport-oper"> <!--机场部分-->
          <a-row style="margin-bottom: 30px;">
            <a-col :span="5">
              <div class="flex-row flex-align-center">
                <span>机场</span>
                <span v-if="props.deviceInfo?.dock?.basic_osd" class="mr5"
                  style="width: 12px; height: 12px; border-radius: 50%; background-color: green; margin-left: 15px;" />
                <span v-else class="mr5"
                  style="width: 12px; height: 12px; border-radius: 50%; background-color: red; margin-left: 15px;" />
                <span>
                    <div v-if="props.deviceInfo?.dock?.basic_osd"
                        style="width: 5vw; height: 3vh;font-size: 0.8vw; margin-left: 20px; text-align: center; color: #49aa19;">
                        {{ EDockModeCodeMap[props.deviceInfo?.dock?.basic_osd?.mode_code as EDockModeCode]}}
                    </div>
                    <div v-else
                        style="width: 5vw; height: 3vh;font-size: 0.8vw; margin-left: 20px; text-align: center; color: red;">
                        {{ EDockModeCodeMap[EDockModeCode.Disconnected] }}
                    </div>
                </span>
              </div>
              <div>
                <img :src="dock3" style="width: 78%; height: 78%;">
                <p>设备型号：{{ device.device_name }}</p>
                <p :title="device.device_sn">设备SN码：{{ formatDeviceSn(device.device_sn) }}</p>
                <p>机场名称：{{ device.nickname }}</p>
              </div>
            </a-col>
            <a-col :span="8">
              <div style="text-align: center; margin-top: 23px; margin-bottom: 5px; font-size: 14px; color: #9b9b9b;">
                <a-row>
                  <a-col :span="6"><span>累计运行时长</span></a-col>
                  <a-col :span="6"><span>作业架次</span></a-col>
                  <a-col :span="6"><span>机场搜星</span></a-col>
                  <a-col :span="6"><span>标定状态</span></a-col>
                </a-row>
              </div>

              <div style="text-align: center; margin-bottom: 15px; font-size: 15px; font-weight: 600;">
                <a-row>
                  <a-col :span="6">
                    <span>
                      <span v-if="props.deviceInfo?.dock?.work_osd?.acc_time >= 2592000"> {{ Math.floor(props.deviceInfo?.dock?.work_osd?.acc_time / 2592000) ?? str }}m </span>
                      <span v-if="(props.deviceInfo?.dock?.work_osd?.acc_time % 2592000) >= 86400"> {{ Math.floor((props.deviceInfo?.dock?.work_osd?.acc_time % 2592000) / 86400) ?? str}}d </span>
                      <span v-if="(props.deviceInfo?.dock?.work_osd?.acc_time % 2592000 % 86400) >= 3600"> {{ Math.floor((props.deviceInfo?.dock?.work_osd?.acc_time % 2592000 % 86400) / 3600) ?? str }}h </span>
                      <span v-if="(props.deviceInfo?.dock?.work_osd?.acc_time % 2592000 % 86400 % 3600) >= 60"> {{ Math.floor((props.deviceInfo?.dock?.work_osd?.acc_time % 2592000 % 86400 % 3600) / 60) ?? str }}min </span>
                      <span>{{ Math.floor(props.deviceInfo?.dock?.work_osd?.acc_time % 2592000 % 86400 % 3600 % 60) ?? str }} s</span>
                    </span>
                  </a-col>
                  <a-col :span="6"><span>{{ props.deviceInfo?.dock?.work_osd?.job_number ?? str }} 次</span></a-col>
                  <a-col :span="6"><span>{{ props.deviceInfo?.dock?.basic_osd?.position_state?.rtk_number ?? str }} </span></a-col>
                  <a-col :span="6"><span>已标定</span></a-col>
                </a-row>
              </div>

              <div style="text-align: center; margin-bottom: 5px; font-size: 14px; color: #9b9b9b;">
                <a-row>
                  <a-col :span="6"><span>工作电压</span></a-col>
                  <a-col :span="6"><span>网络</span></a-col>
                  <a-col :span="6"><span>备降点</span></a-col>
                  <a-col :span="6"><span>空调状态</span></a-col>
                </a-row>
              </div>

              <div style="text-align: center; margin-bottom: 15px; font-size: 15px; font-weight: 600;">
                <a-row>
                  <a-col :span="6"><span>{{ (props.deviceInfo?.dock?.work_osd?.working_voltage ?? str) + ' mV' }}</span></a-col>
                  <a-col :span="6">
                    <span>
                      {{ props.deviceInfo?.dock ? props.deviceInfo?.dock?.basic_osd?.network_state?.rate : str }} kb/s
                    </span>
                  </a-col>
                  <a-col :span="6"><span></span></a-col>
                  <a-col :span="6"><span>{{ props.deviceInfo?.dock?.basic_osd?.air_conditioner?.air_conditioner_state ?? str }}</span></a-col>
                </a-row>
              </div>

              <div style="text-align: center; margin-bottom: 5px; font-size: 14px; color: #9b9b9b;">
                <a-row>
                  <a-col :span="6"><span>蓄电池开关</span></a-col>
                  <a-col :span="6"><span>蓄电池电压</span></a-col>
                  <a-col :span="6"><span>蓄电池温度</span></a-col>
                  <a-col :span="6"><span>舱内温度</span></a-col>
                </a-row>
              </div>

              <div style="text-align: center; margin-bottom: 15px; font-size: 15px; font-weight: 600;">
                <a-row>
                  <a-col :span="6"><span>{{ props.deviceInfo?.dock?.work_osd?.backup_battery?.switch ?? str }}</span></a-col>
                  <a-col :span="6"><span>{{ props.deviceInfo?.dock?.work_osd?.backup_battery?.voltage ?? str }}mV</span></a-col>
                  <a-col :span="6"><span>{{ props.deviceInfo?.dock?.work_osd?.backup_battery?.temperature ?? str }}°C</span></a-col>
                  <a-col :span="6"><span>{{ props.deviceInfo?.dock?.basic_osd?.temperature ?? str }}°C</span></a-col>
                </a-row>
              </div>

              <div style="text-align: center; margin-bottom: 5px; font-size: 14px; color: #9b9b9b;">
                <a-row>
                  <a-col :span="6"><span>舱内湿度</span></a-col>
                  <a-col :span="6"><span>舱外温度</span></a-col>
                  <a-col :span="6"><span>雨量</span></a-col>
                  <a-col :span="6"><span>风速</span></a-col>
                </a-row>
              </div>

              <div style="text-align: center; font-size: 15px; font-weight: 600;">
                <a-row>
                  <a-col :span="6"><span>{{ props.deviceInfo?.dock?.basic_osd?.humidity ?? str }}%</span></a-col>
                  <a-col :span="6"><span>{{ props.deviceInfo?.dock?.basic_osd?.environment_temperature ?? str }}°C</span></a-col>
                  <a-col :span="6"><span>{{ RainfallEnum[props.deviceInfo?.dock?.basic_osd?.rainfall] ?? str }}</span></a-col>
                  <a-col :span="6"><span>{{ (props.deviceInfo?.dock?.basic_osd?.wind_speed ?? str) + ' m/s'}}</span></a-col>
                </a-row>
              </div>

            </a-col>
            <a-col :span="11">
              <div style="margin-left: 30px;">
                <div style="margin-bottom: 10px;">
                  <span style="font-size: 16px; font-weight: 600; margin-right: 10px;">远程调试</span>
                  <a-switch v-model:checked="checked" @click="openDockDebug" style="margin-bottom: 3px;" />
                </div>
                <div style="font-size: 16px; margin-bottom: 15px;">
                  机场控制
                </div>
                <div class="airport-control">
                  <div class="air-con">
                    <a-row>
                      <a-col :span="5">
                        <FundTwoTone style="margin:14px 0px 0px 8px; font-size: 23px;" />
                      </a-col>
                      <a-col :span="11">
                        <p style="margin-bottom: 0px; margin-top: 2px; font-size: 14px;">{{ cmdList[0].label }}</p>
                        <p style="font-weight: 600; font-size: 15px;">{{ cmdList[0].status }}</p>
                      </a-col>
                      <a-col :span="8">
                        <a-button style="margin-top: 8px; margin-right: 5px;"  @click="sendControlCmd(cmdList[0], 0)"
                        :disabled="!checked">{{ cmdList[0].operateText }}</a-button>
                      </a-col>
                    </a-row>
                  </div>
                  <div class="air-con">
                    <a-row>
                      <a-col :span="5">
                        <MacCommandOutlined class="air-icon" />
                      </a-col>
                      <a-col :span="11">
                        <p style="margin-bottom: 0px; margin-top: 2px; font-size: 14px;">{{ cmdList[2].label }}</p>
                        <p style="font-weight: 600; font-size: 15px;">{{ cmdList[2].status }}</p>
                      </a-col>
                      <a-col :span="8">
                        <a-button style="margin-top: 8px; margin-right: 8px;" @click="sendControlCmd(cmdList[2], 2)"
                        :disabled="!checked">{{ cmdList[2].operateText }}</a-button>
                      </a-col>
                    </a-row>
                  </div>
                </div>
                <div class="airport-control">
                  <div class="air-con">
                    <a-row>
                      <a-col :span="5">
                        <svgIcon name="airconditon" style=" color: #248cf0; margin:14px 0px 0px 8px; font-size: 32px;" />
                      </a-col>
                      <a-col :span="11">
                        <p style="margin-bottom: 0px; margin-top: 2px; font-size: 14px;">空调</p>
                        <p style="font-weight: 600; font-size: 15px;">制冷中</p>
                      </a-col>
                      <a-col :span="8">
                        <a-button style="margin-top: 8px; margin-right: 5px;" @click="message.warning('功能暂未开放')" :disabled="!checked">关闭</a-button>
                      </a-col>
                    </a-row>
                  </div>
                  <div class="air-con">
                    <a-row>
                      <a-col :span="5">
                        <SlidersTwoTone style="margin:14px 0px 0px 8px; font-size: 23px;" />
                      </a-col>
                      <a-col :span="11">
                        <p style="margin-bottom: 0px; margin-top: 2px; font-size: 14px;">{{ cmdList[3].label }}</p>
                        <p style="font-weight: 600; font-size: 15px;">{{ cmdList[3].status }}</p>
                      </a-col>
                      <a-col :span="8">
                        <a-button style="margin-top: 8px; margin-right: 8px;" @click="sendControlCmd(cmdList[3], 3)"
                        :disabled="!checked">{{ cmdList[3].operateText }}</a-button>
                      </a-col>
                    </a-row>
                  </div>
                </div>
                <div class="airport-control">
                  <div class="air-con">
                    <a-row>
                      <a-col :span="5">
                        <AlertTwoTone style="margin:14px 0px 0px 8px; font-size: 23px;" />
                      </a-col>
                      <a-col :span="11">
                        <p style="margin-bottom: 0px; margin-top: 2px; font-size: 14px;">{{ cmdList[7].label }}</p>
                        <p style="font-weight: 600; font-size: 15px;">{{ cmdList[7].status }}</p>
                      </a-col>
                      <a-col :span="8">
                        <a-button style="margin-top: 8px; margin-right: 5px;" @click="sendControlCmd(cmdList[7], 7)"
                        :disabled="!checked">{{ cmdList[7].operateText }}</a-button>
                      </a-col>
                    </a-row>
                  </div>
                  <div class="air-con">
                    <a-row>
                      <a-col :span="5">
                        <AlertTwoTone style="margin:14px 0px 0px 8px; font-size: 23px;" />
                      </a-col>
                      <a-col :span="11">
                        <p style="margin-bottom: 0px; margin-top: 2px; font-size: 14px;">{{ cmdList[8].label }}</p>
                        <p style="font-weight: 600; font-size: 15px;">{{ cmdList[8].status }}</p>
                      </a-col>
                      <a-col :span="8">
                        <a-button style="margin-top: 8px; margin-right: 8px;" @click="sendControlCmd(cmdList[8], 8)"
                        :disabled="!checked">{{ cmdList[8].operateText }}</a-button>
                      </a-col>
                    </a-row>
                  </div>
                </div>
                <div class="airport-control">
                  <div class="air-con">
                    <a-row>
                      <a-col :span="5">
                        <SaveTwoTone style="margin:14px 0px 0px 8px; font-size: 23px;" />
                      </a-col>
                      <a-col :span="11">
                        <p style="margin-bottom: 0px; margin-top: 2px; font-size: 14px;">{{ cmdList[5].label }}</p>
                        <p style="font-weight: 600; font-size: 15px;">{{ cmdList[5].status }}</p>
                      </a-col>
                      <a-col :span="8">
                        <a-button style="margin-top: 8px; margin-right: 5px;" @click="sendControlCmd(cmdList[5], 5)"
                        :disabled="!checked">{{ cmdList[5].operateText }}</a-button>
                      </a-col>
                    </a-row>
                  </div>
                  <div class="air-con">
                    <a-row>
                      <a-col :span="5">
                        <SoundTwoTone style="margin:14px 0px 0px 8px; font-size: 23px;" />
                      </a-col>
                      <a-col :span="11">
                        <p style="margin-bottom: 0px; margin-top: 2px; font-size: 14px;">静音模式</p>
                        <p style="font-weight: 600; font-size: 15px;">关闭</p>
                      </a-col>
                      <a-col :span="8">
                        <a-button style="margin-top: 8px; margin-right: 8px;" @click="message.warning('功能暂未开放')" :disabled="!checked">开启</a-button>
                      </a-col>
                    </a-row>
                  </div>
                </div>
                <div>---------------------------------------------------------------------------------</div>
              </div>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="5">
              <div class="flex-row flex-align-center">
                <span>飞行器</span>
                <span v-if="props.deviceInfo?.device" class="mr5"
                style="width: 12px; height: 12px; border-radius: 50%; background-color: green; margin-left: 15px;" />
                <span v-else class="mr5"
                  style="width: 12px; height: 12px; border-radius: 50%; background-color: red; margin-left: 15px;" />
                <span>
                    <div v-if="props.deviceInfo?.device?.mode_code"
                          style="width: 5vw; height: 3vh;font-size: 0.8vw; margin-left: 20px; text-align: center; color: #49aa19;">
                        {{ EDockModeCodeMap[props?.deviceInfo?.device?.mode_code as EDockModeCode] }}
                        </div>
                        <div v-else
                          style="width: 5vw; height: 3vh;font-size: 0.8vw; margin-left: 20px; text-align: center; color: red;">
                          {{ EDockModeCodeMap[EDockModeCode.Disconnected] }}
                        </div>
                </span>
              </div>
              <div>
                <img :src="m4t" style="width: 78%; height: 78%;">
                <p>设备型号：{{ device.children[0].device_name }}</p>
                <p :title="device.children[0].device_sn">设备SN码：{{ formatDeviceSn(device.children[0].device_sn) }}</p>
                <p>飞行器名称：{{ device.children[0].nickname }}</p>
              </div>
            </a-col>
            <a-col :span="8">
              <div style="text-align: center; margin-bottom: 5px; font-size: 14px; color: #9b9b9b;">
                <a-row>
                  <a-col :span="6">累计飞行时长</a-col>
                  <a-col :span="6">飞行架次</a-col>
                  <a-col :span="6">图传</a-col>
                  <a-col :span="6">搜星状态</a-col>
                </a-row>
              </div>
              <div style="text-align: center; font-size: 15px; font-weight: 600;">
                <a-row>
                  <a-col :span="6">
                    <span>
                      <span v-if="props.deviceInfo?.device?.total_flight_time >= 2592000"> {{ Math.floor(props.deviceInfo?.device?.total_flight_time / 2592000) ?? str }}m </span>
                      <span v-if="(props.deviceInfo?.device?.total_flight_time % 2592000) >= 86400"> {{ Math.floor((props.deviceInfo?.device?.total_flight_time % 2592000) / 86400) ?? str}}d </span>
                      <span v-if="(props.deviceInfo?.device?.total_flight_time % 2592000 % 86400) >= 3600"> {{ Math.floor((props.deviceInfo?.device?.total_flight_time % 2592000 % 86400) / 3600) ?? str }}h </span>
                      <span v-if="(props.deviceInfo?.device?.total_flight_time % 2592000 % 86400 % 3600) >= 60"> {{ Math.floor((props.deviceInfo?.device?.total_flight_time % 2592000 % 86400 % 3600) / 60) ?? str }}min </span>
                      <span>{{ Math.floor(props.deviceInfo?.device?.total_flight_time % 2592000 % 86400 % 3600 % 60) ?? str }} s</span>
                    </span>
                  </a-col>
                  <a-col :span="6"><span>{{ props.deviceInfo?.device?.total_flight_sorties ? props.deviceInfo?.device?.total_flight_sorties : str}}架次</span></a-col>
                  <a-col :span="6"><span>--</span></a-col>
                  <a-col :span="6"><span>{{ props.deviceInfo?.device?.position_state?.rtk_number ? props.deviceInfo?.device?.position_state?.rtk_number : str}}</span></a-col>
                </a-row>
              </div>
              <div>-----------------------------------------------------------------</div>
              <div style="text-align: center; margin-bottom: 5px; font-size: 12px; color: #9b9b9b;">
                <a-row>
                  <a-col :span="4"><span></span></a-col>
                  <a-col :span="4"><span>循环次数</span></a-col>
                  <a-col :span="4"><span>高电量存储</span></a-col>
                  <a-col :span="4"><span>电压</span></a-col>
                  <a-col :span="4"><span>温度</span></a-col>
                  <a-col :span="4"><span>电量</span></a-col>
                </a-row>
              </div>
              <div style="text-align: center; font-size: 15px; font-weight: 600;">
                <a-row>
                  <a-col :span="4"><span
                      style="text-align: center; margin-bottom: 5px; font-size: 12px; color: #9b9b9b;">电池</span></a-col>
                  <a-col :span="4"><span>{{ props.deviceInfo?.device?.battery?.batteries[0]?.loop_times ? props.deviceInfo?.device?.battery?.batteries[0]?.loop_times : str}}</span></a-col>
                  <a-col :span="4"><span>{{ props.deviceInfo?.device?.battery?.batteries[0]?.high_voltage_storage_days ? props.deviceInfo?.device?.battery?.batteries[0]?.high_voltage_storage_days : str}} 天</span></a-col>
                  <a-col :span="4"><span>{{ props.deviceInfo?.device?.battery?.batteries[0]?.voltage ? props.deviceInfo?.device?.battery?.batteries[0]?.voltage : str}} mV</span></a-col>
                  <a-col :span="4"><span>{{ props.deviceInfo?.device?.battery?.batteries[0]?.temperature ? props.deviceInfo?.device?.battery?.batteries[0]?.temperature : str}} °C</span></a-col>
                  <a-col :span="4"><span>{{ props.deviceInfo?.device?.battery.capacity_percent !== str ? (props.deviceInfo?.device?.battery.capacity_percent ?? str) + ' %' : str}}</span></a-col>
                </a-row>
              </div>
              <div class="drone-control">
                <div class="dro-con">
                  <a-row>
                    <a-col :span="19">
                      <span>{{ deviceSetting[DeviceSettingKeyEnum.NIGHT_LIGHTS_MODE_SET].label }}</span>
                    </a-col>
                    <a-col :span="5">
                      <span>{{ deviceSetting[DeviceSettingKeyEnum.NIGHT_LIGHTS_MODE_SET].value ? deviceSetting[DeviceSettingKeyEnum.NIGHT_LIGHTS_MODE_SET].value : str }}</span>
                      <span>
                          <DeviceSettingPopover
                              :visible="deviceSetting[DeviceSettingKeyEnum.NIGHT_LIGHTS_MODE_SET].popConfirm.visible"
                              :loading="deviceSetting[DeviceSettingKeyEnum.NIGHT_LIGHTS_MODE_SET].popConfirm.loading"
                              @confirm="onConfirm(deviceSetting[DeviceSettingKeyEnum.NIGHT_LIGHTS_MODE_SET].settingKey)"
                              @cancel="onCancel(deviceSetting[DeviceSettingKeyEnum.NIGHT_LIGHTS_MODE_SET].settingKey)"
                          >
                              <template #formContent>
                                  <div class="form-content">
                                      <span class="form-label">{{ deviceSetting[DeviceSettingKeyEnum.NIGHT_LIGHTS_MODE_SET].label }}:</span>
                                      <a-switch checked-children="开" un-checked-children="关" v-model:checked="deviceSettingFormModel.nightLightsState" />
                                  </div>
                              </template>
                              <EditTwoTone @click="onShowPopConfirm(deviceSetting[DeviceSettingKeyEnum.NIGHT_LIGHTS_MODE_SET].settingKey)"/>
                          </DeviceSettingPopover>
                      </span>
                    </a-col>
                  </a-row>
                </div>
                <div class="dro-con">
                  <a-row>
                    <a-col :span="19">
                      <span>备降转移高
                        <a-popover placement="bottom">
                          <template #content>
                            <h4>备降转移高（20-100m）是飞行器</h4>
                            <h4>从机场上方飞向备降点时相对机场</h4>
                            <h4>的高度</h4>
                            <img :src="image">
                          </template>
                          <ExclamationCircleTwoTone style="margin-left: 3px;" />
                        </a-popover>
                      </span>
                    </a-col>
                    <a-col :span="5">
                      <span>30m</span>
                    </a-col>
                  </a-row>
                </div>
              </div>
              <div class="drone-control">
                <div class="dro-con">
                  <a-row>
                    <a-col :span="19">
                      <span>{{ deviceSetting[DeviceSettingKeyEnum.DISTANCE_LIMIT_SET].label }}
                        <a-popover placement="bottom">
                          <template #content>
                            <h4>限远（15-8000m）是约束飞行器相对</h4>
                            <h4>机场的最大作业距离</h4>
                          </template>
                          <ExclamationCircleTwoTone style="margin-left: 3px;" />
                        </a-popover>
                      </span>
                    </a-col>
                    <a-col :span="5">
                      <span>{{ deviceSetting[DeviceSettingKeyEnum.DISTANCE_LIMIT_SET].value ? deviceSetting[DeviceSettingKeyEnum.DISTANCE_LIMIT_SET].value : str }}</span>
                      <span>
                          <DeviceSettingPopover
                              :visible="deviceSetting[DeviceSettingKeyEnum.DISTANCE_LIMIT_SET].popConfirm.visible"
                              :loading="deviceSetting[DeviceSettingKeyEnum.DISTANCE_LIMIT_SET].popConfirm.loading"
                              @confirm="onConfirm(deviceSetting[DeviceSettingKeyEnum.DISTANCE_LIMIT_SET].settingKey)"
                              @cancel="onCancel(deviceSetting[DeviceSettingKeyEnum.DISTANCE_LIMIT_SET].settingKey)"
                          >
                              <template #formContent>
                              <div class="form-content">
                                  <span class="form-label">{{ deviceSetting[DeviceSettingKeyEnum.DISTANCE_LIMIT_SET].label }}:</span>
                                  <a-switch style="margin-right: 10px;" checked-children="开" un-checked-children="关" v-model:checked="deviceSettingFormModel.distanceLimitStatus.state" />
                                  <a-input-number v-model:value="deviceSettingFormModel.distanceLimitStatus.distanceLimit" :min="15" :max="8000" />
                                  m
                              </div>
                              </template>
                              <EditTwoTone @click="onShowPopConfirm(deviceSetting[DeviceSettingKeyEnum.DISTANCE_LIMIT_SET].settingKey)"/>
                          </DeviceSettingPopover>
                      </span>
                    </a-col>
                  </a-row>
                </div>
                <div class="dro-con">
                  <a-row>
                    <a-col :span="17">
                      <span>{{ deviceSetting[DeviceSettingKeyEnum.HEIGHT_LIMIT_SET].label }}
                        <a-popover placement="bottom">
                          <template #content>
                            <h4>限高是约束飞行器相对</h4>
                            <h4>机场的最大作业高度，限高范围（20 -</h4>
                            <h4>1500m）</h4>
                          </template>
                          <ExclamationCircleTwoTone style="margin-left: 3px;" />
                        </a-popover>
                      </span>
                    </a-col>
                    <a-col :span="7">
                      <span>{{ deviceSetting[DeviceSettingKeyEnum.HEIGHT_LIMIT_SET].value ? deviceSetting[DeviceSettingKeyEnum.HEIGHT_LIMIT_SET].value : str }}</span>
                      <span>
                          <DeviceSettingPopover
                              :visible="deviceSetting[DeviceSettingKeyEnum.HEIGHT_LIMIT_SET].popConfirm.visible"
                              :loading="deviceSetting[DeviceSettingKeyEnum.HEIGHT_LIMIT_SET].popConfirm.loading"
                              @confirm="onConfirm(deviceSetting[DeviceSettingKeyEnum.HEIGHT_LIMIT_SET].settingKey)"
                              @cancel="onCancel(deviceSetting[DeviceSettingKeyEnum.HEIGHT_LIMIT_SET].settingKey)"
                          >
                              <template #formContent>
                              <div class="form-content">
                                  <span class="form-label">{{ deviceSetting[DeviceSettingKeyEnum.HEIGHT_LIMIT_SET].label }}:</span>
                                  <a-input-number v-model:value="deviceSettingFormModel.heightLimit" :min="20" :max="1500" />
                                  m
                              </div>
                              </template>
                              <EditTwoTone @click="onShowPopConfirm(deviceSetting[DeviceSettingKeyEnum.HEIGHT_LIMIT_SET].settingKey)"/>
                          </DeviceSettingPopover>
                      </span>
                    </a-col>
                  </a-row>
                </div>
              </div>
              <div class="drone-control">
                <div class="dro-con">
                  <a-row>
                    <a-col :span="19">
                      <span>{{ deviceSetting[DeviceSettingKeyEnum.OBSTACLE_AVOIDANCE_HORIZON].label }}
                        <a-popover placement="bottom">
                          <template #content>
                            <h4>飞行器的避障工作状态显示，可以</h4>
                            <h4>快速开启/关闭飞行器避障</h4>
                          </template>
                          <ExclamationCircleTwoTone style="margin-left: 3px;" />
                        </a-popover>
                      </span>
                    </a-col>
                    <a-col :span="5">
                      <span>{{ deviceSetting[DeviceSettingKeyEnum.OBSTACLE_AVOIDANCE_HORIZON].value ? deviceSetting[DeviceSettingKeyEnum.OBSTACLE_AVOIDANCE_HORIZON].value : str}}</span>
                      <span>
                          <DeviceSettingPopover
                              :visible="deviceSetting[DeviceSettingKeyEnum.OBSTACLE_AVOIDANCE_HORIZON].popConfirm.visible"
                              :loading="deviceSetting[DeviceSettingKeyEnum.OBSTACLE_AVOIDANCE_HORIZON].popConfirm.loading"
                              @confirm="onConfirm(deviceSetting[DeviceSettingKeyEnum.OBSTACLE_AVOIDANCE_HORIZON].settingKey)"
                              @cancel="onCancel(deviceSetting[DeviceSettingKeyEnum.OBSTACLE_AVOIDANCE_HORIZON].settingKey)"
                          >
                              <template #formContent>
                              <div class="form-content">
                                  <span class="form-label">{{ deviceSetting[DeviceSettingKeyEnum.OBSTACLE_AVOIDANCE_HORIZON].label }}:</span>
                                  <a-switch checked-children="开" un-checked-children="关" v-model:checked="deviceSettingFormModel.obstacleAvoidanceHorizon" />
                              </div>
                              </template>
                              <EditTwoTone @click="onShowPopConfirm(deviceSetting[DeviceSettingKeyEnum.OBSTACLE_AVOIDANCE_HORIZON].settingKey)"/>
                          </DeviceSettingPopover>
                      </span>
                    </a-col>
                  </a-row>
                </div>
                <div class="dro-con">
                  <a-row>
                    <a-col :span="16">
                      <span>运行模式
                        <a-popover placement="bottom">
                          <template #content>
                            <h4>运行模式即飞行器电池充电管理模</h4>
                            <h4>式，请根据您实际作业场景选择运行</h4>
                            <h4>模式</h4>
                          </template>
                          <ExclamationCircleTwoTone style="margin-left: 3px;" />
                        </a-popover>
                      </span>
                    </a-col>
                    <a-col :span="8">
                      <span>待命
                        <a-popover placement="top" trigger="click">
                          <template #content>
                            <h4><ExclamationCircleTwoTone two-tone-color="#faad14" style="margin-right: 5px;" />计划模式适合规律作业场景，无任务时电池电量保持在</h4>
                            <h4>55%~60%， 电池寿命较长。待命模式适合应急作业场</h4>
                            <h4>景，无任务时电池电量保 持在90%~95%，电池寿命较</h4>
                            <h4>短。</h4>
                          <a-select v-model="selectedMode" placeholder="待命" style="width: 150px;">
                            <a-select-option value="计划">计划</a-select-option>
                            <a-select-option value="待命">待命</a-select-option>
                          </a-select>
                          <div style="margin-left: 55%;">
                            <a-button style="margin-right: 10px;">取消</a-button>
                            <a-button type="primary">确定</a-button>
                          </div>
                          </template>
                          <EditTwoTone style="margin-left: 3px;" />
                        </a-popover>
                      </span>
                    </a-col>
                  </a-row>
                </div>
              </div>
              <div class="drone-control">
                <div class="dro-con">
                  <a-row>
                    <a-col :span="16">
                      <span>自动录制
                        <a-popover placement="bottom">
                          <template #content>
                            <h4>设置手动飞行时是否自动开启视频录</h4>
                            <h4>制</h4>
                          </template>
                          <ExclamationCircleTwoTone style="margin-left: 3px;" />
                        </a-popover>
                      </span>
                    </a-col>
                    <a-col :span="8">
                      <span>关闭
                        <a-popover placement="top">
                          <template #content>
                            <a-switch v-model:checked="checked1" />
                          </template>
                          <EditTwoTone style="margin-left: 3px;" />
                        </a-popover>

                      </span>
                    </a-col>
                  </a-row>
                </div>
                <div class="dro-con">
                  <a-row>
                    <a-col :span="14">
                      <span>飞行速度
                        <a-popover placement="bottom">
                          <template #content>
                            <h4>手动控制飞行设备前进后退，左右移</h4>
                            <h4>动的最大速度（默认5m/s）</h4>
                          </template>
                          <ExclamationCircleTwoTone style="margin-left: 3px;" />
                        </a-popover>
                      </span>
                    </a-col>
                    <a-col :span="10">
                      <span>12m/s
                        <a-popover placement="top">
                          <template #content>
                            <h4><ExclamationCircleTwoTone two-tone-color="#faad14" style="margin-right: 5px;" />
                              飞行速度
                            <a-input v-model:value="value_fly" style="width: 65px;"></a-input>
                            m/s。</h4>
                          <div style="margin-left: 11%; margin-top: 20px;">
                            <a-button style="margin-right: 10px; height: 30px;">取消</a-button>
                            <a-button style="height: 30px;" type="primary">确定</a-button>
                          </div>
                          </template>
                          <EditTwoTone style="margin-left: 3px;" />
                        </a-popover>
                      </span>
                    </a-col>
                  </a-row>
                </div>
              </div>
            </a-col>
            <a-col :span="11">
              <div style="margin-left: 30px;">
                <div style="font-size: 16px; margin-bottom: 15px;">
                  飞行器控制
                </div>
                <div class="airport-control">
                  <div class="air-con">
                    <a-row>
                      <a-col :span="5">
                        <PoweroffOutlined style="margin:14px 0px 0px 8px; font-size: 23px; color: #248cf0;" />
                      </a-col>
                      <a-col :span="11">
                        <p style="margin-bottom: 0px; margin-top: 2px; font-size: 14px;">{{ cmdList[1].label }}</p>
                        <p style="font-weight: 600; font-size: 15px;">{{ cmdList[1].status }}</p>
                      </a-col>
                      <a-col :span="8">
                        <a-button style="margin-top: 8px; margin-right: 5px;" @click="sendControlCmd(cmdList[1], 1)"
                        :disabled="!checked">{{ cmdList[1].operateText }}</a-button>
                      </a-col>
                    </a-row>
                  </div>
                  <div class="air-con">
                    <a-row>
                      <a-col :span="5">
                        <svgIcon name="battery" style="margin:14px 0px 0px 8px; font-size: 28px; color: #248cf0;" />
                      </a-col>
                      <a-col :span="11">
                        <p style="margin-bottom: 0px; margin-top: 2px; font-size: 14px;">{{ cmdList[4].label }}</p>
                        <p style="font-weight: 600; font-size: 15px;">{{ cmdList[4].status }}</p>
                      </a-col>
                      <a-col :span="8">
                        <a-button style="margin-top: 8px; margin-right: 8px;" @click="sendControlCmd(cmdList[4], 4)"
                        :disabled="!checked">{{ cmdList[4].operateText }}</a-button>
                      </a-col>
                    </a-row>
                  </div>
                </div>
                <div class="airport-control">
                  <div class="air-con">
                    <a-row>
                      <a-col :span="5">
                        <svgIcon name="4G" style="margin:14px 0px 0px 8px; font-size: 28px; color: #248cf0;" />
                      </a-col>
                      <a-col :span="11">
                        <p style="margin-bottom: 0px; margin-top: 2px; font-size: 14px;">{{ cmdList[11].label }}</p>
                        <p style="font-weight: 600; font-size: 15px;">{{ cmdList[11].status }}</p>
                      </a-col>
                      <a-col :span="8">
                        <a-button style="margin-top: 8px; margin-right: 5px;" @click="sendControlCmd(cmdList[11], 11)"
                        :disabled="!checked">{{ cmdList[11].operateText }}</a-button>
                      </a-col>
                    </a-row>
                  </div>
                  <div class="air-con">
                    <a-row>
                      <a-col :span="5">
                        <SaveTwoTone style="margin:14px 0px 0px 8px; font-size: 23px;" />
                      </a-col>
                      <a-col :span="11">
                        <p style="margin-bottom: 0px; margin-top: 2px; font-size: 14px;">{{ cmdList[6].label }}</p>
                        <p style="font-weight: 600; font-size: 15px;">{{ cmdList[6].status }}</p>
                      </a-col>
                      <a-col :span="8">
                        <a-button style="margin-top: 8px; margin-right: 8px;" @click="sendControlCmd(cmdList[6], 6)"
                        :disabled="!checked">{{ cmdList[6].operateText }}</a-button>
                      </a-col>
                    </a-row>
                  </div>
                </div>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
    </a-modal>
  </customSidebar>
</template>
<script lang="ts" setup>
import customSidebar from '/@/components/common/customSidebar.vue'
import { ColumnProps, TableState } from 'ant-design-vue/lib/table/interface'
import { h, onMounted, reactive, ref, UnwrapRef, computed, defineProps, watch, nextTick } from 'vue'
import { IPage } from '/@/api/http/type'
import { BindBody, bindDevice, getBindingDevices, unbindDevice, updateDevice, getAllUsersInfo, getMqttBindingCode, formatDeviceSn } from '/@/api/manage'
import { EBizCode, EDeviceTypeName, ELocalStorageKey } from '/@/types'
import {
  EditOutlined, CheckOutlined, CloseOutlined, DeleteOutlined, FileSearchOutlined, CloudServerOutlined, AlertTwoTone, SecurityScanTwoTone, FundTwoTone,
  MacCommandOutlined, SaveTwoTone, SoundTwoTone, SlidersTwoTone, EditTwoTone, ExclamationCircleTwoTone, SettingTwoTone, DeleteTwoTone, EyeTwoTone,
  PlusCircleTwoTone, EllipsisOutlined, PoweroffOutlined, SignalFilled, GlobalOutlined
} from '@ant-design/icons-vue'
import { Device, DeviceFirmwareStatusEnum, DeviceInfoType, NetworkStateTypeEnum, RainfallEnum, EDockModeCode, EDockModeCodeMap, OnlineDevice } from '/@/types/device'
import DeviceFirmwareUpgrade from '/@/components/devices/device-upgrade/DeviceFirmwareUpgrade.vue'
import DeviceFirmwareUpgradeModal from '/@/components/devices/device-upgrade/DeviceFirmwareUpgradeModal.vue'
import { useDeviceFirmwareUpgrade } from '/@/components/devices/device-upgrade/use-device-upgrade'
import { useDeviceUpgradeEvent } from '/@/components/devices/device-upgrade/use-device-upgrade-event'
import { DeviceCmdExecuteInfo, DeviceCmdExecuteStatus, cmdList as baseCmdList, DeviceCmdItem } from '/@/types/device-cmd'
import DeviceLogUploadRecordDrawer from '/@/components/devices/device-log/DeviceLogUploadRecordDrawer.vue'
import DeviceHmsDrawer from '/@/components/devices/device-hms/DeviceHmsDrawer.vue'
import { message, notification } from 'ant-design-vue'
import dayjs, { Dayjs } from 'dayjs'
import { getAlarmPage, AlarmPageRequest, deletAlarm, AlarmParam } from '/@/api/alarm'
import { userDeviceRelationPage, SettingPageRequest, delectUserDeviceRelation, saveOrUpdateUserDeviceRelation, userDeviceRelationList, userDeviceRelationWorkspaceList } from '/@/api/device-setting'
import { useDockControl } from '/@/components/g-map/use-dock-control'
import { useMyStore } from '/@/store'
import { initDeviceSetting, initDeviceSettingFormModel, DeviceSettingKeyEnum } from '/@/types/device-setting'
import { updateDeviceSettingInfoByOsd, updateDeviceSettingFormModelByOsd } from '/@/utils/device-setting'
import { useDeviceSetting } from '/@/components/g-map/use-device-setting'
import DeviceSettingPopover from '/@/components/g-map/DeviceSettingPopover.vue'
import { cloneDeep } from 'lodash'
import { handleMessage, initMessageHandler } from '/@/utils/websocket-message-handler'
import { useConnectWebSocket } from '/@/hooks/use-connect-websocket'
import peopleIcon from '/@/assets/icons/people.svg'
import dock3 from '/@/assets/icons/dock/dock_3.png'
import m4t from '/@/assets/icons/drone/m4t.png'
import image from '/@/assets/icons/image.png'
import { getDictList, getSensorPage, SensorPageRequest } from '/@/api/algCode'
import { useRouter } from 'vue-router'
import SvgIcon from '/@/components/svgIcon.vue'
import { updateAirportDeviceStatus } from '/@/api/insp-device'
import { getUserDronePilotsByDepartment } from '/@/api/polituser'
import auth from '/@/plugins/auth'

const store = useMyStore()

const router = useRouter()

// 初始化消息处理器
initMessageHandler(store)
// 监听ws 消息
useConnectWebSocket(handleMessage)
const str: string = '--'

const rowZibreClassName = (_record: any, index: any) => (index % 2 === 0 ? 'even-row' : 'odd-row')

function parseTime (time, pattern) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time.replace(/-/g, '/').replace('T', ' ').replace(/\.[\d]{3}/g, '')
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

const drawerVisible = ref(false)
const settingDrawerVisible = ref(false)
const showSettingModal = ref(false)
const searchName = ref('')

const sensorVisible = ref(false)

const openSettingDrawer = async (record : any) => {
  device.value = record
  fetchSettingData()
  getUserDeviceRelationWorkspace()
  settingDrawerVisible.value = true
}

const alaData = ref<AlarmParam[]>([])
const sensorData = ref([])
const settingData = ref<any[]>([])

const alarmLevelConfig = {
  1: { text: '重大（一级）', color: 'red' },
  2: { text: '较大（二级）', color: 'orange' },
  3: { text: '一般（三级）', color: 'blue' }
}

const columns1 = [
  { title: '设备型号', dataIndex: 'device_name', key: 'device_name', align: 'center' },
  { title: '告警时间', dataIndex: 'alarm_time', key: 'alarm_time', align: 'center' },
  { title: '告警等级', dataIndex: 'alarm_level', key: 'alarm_level', align: 'center' },
  { title: '告警信息', dataIndex: 'alarm_message', key: 'alarm_message', align: 'center' }
]

const settingColumns = [
  { title: '使用人', dataIndex: 'username', key: 'username', align: 'center' },
  { title: '所属部门', dataIndex: 'workspace_name', key: 'workspace_name', align: 'center' },
  { title: '授权状态', dataIndex: 'status', key: 'status', align: 'center', customCell: ({ text }: { text: string }) => getAuthStatusName(text) },
  { title: '操作', key: 'action', align: 'center' }
]

const sensorColumns = [
  { title: '设备名称', dataIndex: 'deviceName', key: 'deviceName', align: 'center' },
  { title: '设备编号', dataIndex: 'deviceSn', key: 'deviceSn', align: 'center', ellipsis: true },
  { title: '消息主题', dataIndex: 'topic', key: 'topic', align: 'center', ellipsis: true },
  { title: '方法', dataIndex: 'method', key: 'method', align: 'center', ellipsis: true },
  { title: 'MQTT消息', dataIndex: 'message', key: 'message', align: 'center', ellipsis: true },
  { title: '上送时间', dataIndex: 'timestamp', key: 'timestamp', align: 'center', ellipsis: true },
  { title: '操作', key: 'action', align: 'center' }
]

const pagination = reactive({ current: 1, pageSize: 10, total: 0 })
const device = ref<Device | Record<string, any>>({})
const deviceName = ref('')

const alarmLevel = ref(null)
const dataTime = ref([])
const authStatus = ref('')
function fetchSettingData () {
  const queryParam: SettingPageRequest = {
    page: pagination.current,
    page_size: pagination.pageSize,
    param: {
      user_name: searchName.value,
      device_sn: device.value.device_sn,
      workspace_id: userDeviceRelationWorkspace.value,
      status: authStatus.value
    }
  }
  userDeviceRelationPage(queryParam).then((res:any) => {
    if (res && res.code === 0) {
      settingData.value = res.data.list
      pagination.total = res.data.pagination.total || 0
    }
  })
}

const openDrawer = async (record) => {
  deviceName.value = record.children[0].nickname
  fetchData(false)
  drawerVisible.value = true
}

const alarmPaginationProp = reactive({
  current: 1,
  pageSize: 10,
  total: 0,
  pageSizeOptions: ['10', '20', '50'],
  showQuickJumper: true,
  showSizeChanger: true,
  showTotal: (total: number) => `总计 ${total} 条`
})

const handleTableChange = (pag: any) => {
  if (pag) {
    alarmPaginationProp.current = pag.current || 1
    alarmPaginationProp.pageSize = pag.pageSize || 10
  }
  fetchData(false)
}

function fetchData (resetPage = false) {
  if (resetPage) {
    alarmPaginationProp.current = 1
  }
  const [startMoment, endMoment] = dataTime.value
  const startStr = startMoment ? startMoment.format('YYYY-MM-DD') + ' 00:00:00' : ''
  const endStr = endMoment ? endMoment.format('YYYY-MM-DD') + ' 23:59:59' : ''

  const queryParam: AlarmPageRequest = {
    page: alarmPaginationProp.current,
    page_size: alarmPaginationProp.pageSize,
    param: {
      device_name: deviceName.value,
      alarm_level: alarmLevel.value,
      start_time: startStr,
      end_time: endStr
    }
  }
  getAlarmPage(queryParam).then(res => {
    if (res && res.code === 0) {
      alaData.value = res.data.list
      alarmPaginationProp.total = res.data.pagination.total || 0
    }
  })
}

const handleDeviceUseStatus = async (record, newStatus, type) => {
  const operationText = newStatus === 1 ? '停用' : '启用'
  try {
    const res = await updateAirportDeviceStatus(record.device_sn, newStatus.toString())

    if (res.code === 0) {
      record.use_status = newStatus
      message.success(`设备${operationText}成功！`)
    } else {
      console.error(`设备${operationText}失败：${res.msg || '接口返回异常'}`)
    }
  } catch (error) {
    if (error?.name !== 'CanceledError') {
      console.error(`设备${operationText}失败：`, error)
    }
  }
}

const deviceSn = ref('')

const openSensorDrawer = async (record) => {
  sensorLoading.value = true
  deviceSn.value = record.device_sn
  sensorVisible.value = true
  selectedDate.value = dayjs()
  await nextTick()
  try {
    await fetchSensorData(false)
  } catch (error) {
    console.error('打开传感器抽屉失败:', error)
  }
}

const sensorPaginationProp = reactive({
  current: 1,
  pageSize: 10,
  total: 0,
  pageSizeOptions: ['10', '20', '50', '100'],
  showQuickJumper: true,
  showSizeChanger: true,
  showTotal: (total: number) => `总计 ${total} 条`
})

const selectedDate = ref(null)

const sensorLoading = ref(false)

async function fetchSensorData (resetPage = false) {
  sensorLoading.value = true

  try {
    if (resetPage) {
      sensorPaginationProp.current = 1
    }

    let startTime = ''
    let endTime = ''

    // 如果有选择的日期，使用该日期的00:00:00到23:59:59
    if (selectedDate.value) {
      const selectedDay = dayjs(selectedDate.value)
      startTime = selectedDay.startOf('day').format('YYYY-MM-DD HH:mm:ss')
      endTime = selectedDay.endOf('day').format('YYYY-MM-DD HH:mm:ss')
    } else {
      // 没有选择日期时，使用当天
      const today = dayjs()
      startTime = today.startOf('day').format('YYYY-MM-DD HH:mm:ss')
      endTime = today.endOf('day').format('YYYY-MM-DD HH:mm:ss')
    }

    const queryParam: SensorPageRequest = {
      page: sensorPaginationProp.current,
      page_size: sensorPaginationProp.pageSize,
      param: {
        sn: deviceSn.value,
        startTime: startTime,
        endTime: endTime
      }
    }
    const res = await getSensorPage(queryParam)

    if (res && res.code === 0) {
      sensorData.value = res.data.list || []
      sensorPaginationProp.total = res.data.pagination?.total || 0
    } else {
      console.error('获取传感器数据失败:', res?.message || '未知错误')
      sensorData.value = []
      sensorPaginationProp.total = 0
    }
  } catch (error) {
    console.error('获取传感器数据异常:', error)
    sensorData.value = []
    sensorPaginationProp.total = 0
  } finally {
    sensorLoading.value = false
  }
}

const handleSensorChange = (pag: any) => {
  if (pag) {
    sensorPaginationProp.current = pag.current || 1
    sensorPaginationProp.pageSize = pag.pageSize || 10
  }
  fetchSensorData(false)
}

function resetSensorSearch () {
  selectedDate.value = dayjs()
  fetchSensorData(true)
}

const sensorMessageVisible = ref(false)
const selectMessageRecord = ref('')
const currentRecord = ref([])
const parsedMessage = ref(null)
const showRawJson = ref(false)

function parseMessage (message) {
  if (!message) {
    parsedMessage.value = null
    return
  }
  try {
    const jsonObj = typeof message === 'string' ? JSON.parse(message) : message
    parsedMessage.value = jsonObj
  } catch (e) {
    console.error('解析JSON失败:', e)
    parsedMessage.value = null
  }
}

const messageDetail = async (record) => {
  sensorMessageVisible.value = true
  selectMessageRecord.value = record
  currentRecord.value = record
  parseMessage(record.message)
}

function copyMessage (message) {
  if (!message) {
    return
  }
  // 复制格式化后的JSON内容
  const formattedMessage = formatJsonMessage(message)

  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(formattedMessage).then(() => {
      message.success('复制成功')
    }).catch(() => {
      message.error('复制失败')
    })
  } else {
    // 降级方案
    const textArea = document.createElement('textarea')
    textArea.value = formattedMessage
    textArea.style.position = 'fixed'
    textArea.style.left = '-999999px'
    textArea.style.top = '-999999px'
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()
    try {
      document.execCommand('copy')
      message.success('复制成功')
    } catch (err) {
      message.error('复制失败')
    }
    document.body.removeChild(textArea)
  }
}

function formatJsonMessage (message) {
  if (!message) {
    return ''
  }
  try {
    // 尝试解析JSON
    const jsonObj = typeof message === 'string' ? JSON.parse(message) : message
    // 格式化JSON，使用2个空格缩进
    return JSON.stringify(jsonObj, null, 2)
  } catch (e) {
    // 如果解析失败，返回原始内容
    return message
  }
}

function getWarningLevelText (level) {
  const levelMap = {
    0: '无危险',
    1: '等级一',
    2: '等级二',
    3: '等级三',
    4: '等级四'
  }
  return levelMap[level] || `级别${level}`
}
/** 获取警告级别标签类型 */
function getWarningLevelType (level) {
  const typeMap = {
    0: 'info',
    1: 'warning',
    2: 'warning',
    3: 'danger',
    4: 'danger'
  }
  return typeMap[level] || 'info'
}
function getVertTrendType (trend) {
  const typeMap = {
    0: 'info',
    1: 'success',
    2: 'warning'
  }
  return typeMap[trend] || 'info'
}
function getVertTrendText (trend) {
  const trendMap = {
    0: '相对高度不变',
    1: '相对高度上升',
    2: '相对高度下降'
  }
  return trendMap[trend] || `趋势${trend}`
}

function handleCloseDetail () {
  sensorMessageVisible.value = false
  parsedMessage.value = null
  showRawJson.value = false
  currentRecord.value = null
}

const sensorMessageColumns = [
  {
    title: '序号',
    key: 'index',
    width: 60,
    align: 'center'
  },
  {
    title: '飞机地址',
    dataIndex: 'icao',
    key: 'icao',
    width: 100,
    align: 'center'
  },
  {
    title: '警告级别',
    dataIndex: 'warning_level',
    key: 'warning_level',
    width: 100,
    align: 'center'
  },
  {
    title: '水平距离(m)',
    dataIndex: 'distance',
    key: 'distance',
    width: 110,
    align: 'center'
  },
  {
    title: '绝对高度类型',
    dataIndex: 'altitude_type',
    key: 'altitude_type',
    width: 120,
    align: 'center'
  },
  {
    title: '绝对高度(m)',
    dataIndex: 'altitude',
    key: 'altitude',
    width: 100,
    align: 'center'
  },
  {
    title: '相对高度(m)',
    dataIndex: 'relative_altitude',
    key: 'relative_altitude',
    width: 110,
    align: 'center'
  },
  {
    title: '航向(°)',
    dataIndex: 'heading',
    key: 'heading',
    width: 100,
    align: 'center'
  },
  {
    title: '高度变化趋势',
    dataIndex: 'vert_trend',
    key: 'vert_trend',
    width: 120,
    align: 'center'
  },
  {
    title: '纬度',
    dataIndex: 'latitude',
    key: 'latitude',
    width: 120,
    align: 'center'
  },
  {
    title: '经度',
    dataIndex: 'longitude',
    key: 'longitude',
    width: 120,
    align: 'center'
  }
]

function getWarningLevelColor (level) {
  const colorMap = {
    0: 'default',
    1: 'orange',
    2: 'orange',
    3: 'red',
    4: 'red'
  }
  return colorMap[level] || 'default'
}

// 获取高度变化趋势颜色
function getVertTrendColor (trend) {
  const colorMap = {
    0: 'default',
    1: 'green',
    2: 'volcano'
  }
  return colorMap[trend] || 'default'
}

const createForm = reactive<{
  status: string
  term: string
  reason: string
  remark: string
  user_ids: string[]
  user_names: string
  device_sn: string
  start_time: string
  end_time: string
  valid_date: any[]
}>({
  status: 'IN_EFFECT',
  term: '',
  reason: '',
  remark: '',
  user_ids: [],
  user_names: '',
  device_sn: '',
  start_time: '',
  end_time: '',
  valid_date: []
})
const authStatusDataList = ref<any[]>([])
const authTermDataList = ref<any[]>([])
async function getAuthStatus () {
  const res = await getDictList('auth_status')
  if (res && res.code === 0) {
    authStatusDataList.value = res.data
  }
}
async function getAuthTerm () {
  const res = await getDictList('auth_term')
  if (res && res.code === 0) {
    authTermDataList.value = res.data
  }
}

function getAuthStatusName (id: string) {
  const found = authStatusDataList.value.find(opt => String(opt.dictValue) === String(id))
  return found ? found.dictLabel : id
}

function getAuthTermName (id: string) {
  const found = authTermDataList.value.find(opt => String(opt.dictValue) === String(id))
  return found ? found.dictLabel : id
}

const showAuthDetailModal = ref(false)
const authDetail = ref<any>({})
const authHistory = ref<any[]>([])

// 查看详情
async function onViewSetting (record: any) {
  authDetail.value = record
  authDetail.value.valid_date = record.start_time + '-' + (record.term === 0 ? '-' : record.end_time)
  fetchSettingData2()
}

function fetchSettingData2 () {
  const param = {
    status: authStatus.value,
    device_sn: device.value.device_sn,
    user_name: '',
    workspace_id: userDeviceRelationWorkspace.value,
    user_id: authDetail.value.user_id
  }
  userDeviceRelationList(param).then(res => {
    if (res && res.code === 0) {
      authHistory.value = Array.isArray(res.data) ? res.data : []
      // authDetail.value.valid_date = authHistory.value[0].start_time + '-' + (authHistory.value[0].term === 1 ? '-' : authHistory.value[0].end_time)
      authHistory.value.forEach(e => { e.valid_date = e.start_time + '-' + (e.term === 0 ? '-' : e.end_time) })
      showAuthDetailModal.value = true
    }
  })
}

function handleCreateSettingOk () {
  console.log('确认', createForm)
  createForm.device_sn = device.value.device_sn
  createForm.start_time = dayjs(createForm.valid_date[0]).format('YYYY-MM-DD HH:mm:ss')
  createForm.end_time = dayjs(createForm.valid_date[1]).format('YYYY-MM-DD HH:mm:ss')
  saveOrUpdateUserDeviceRelation(createForm).then(res => {
    if (res && res.code === 0) {
      message.info('保存成功')
      fetchSettingData()
      resetCreatSettingForm()
    }
  })
}

function resetCreatSettingForm () {
  createForm.status = 'IN_EFFECT'
  createForm.term = ''
  createForm.reason = ''
  createForm.remark = ''
  createForm.user_ids = []
  createForm.user_names = ''
  createForm.device_sn = ''
  createForm.start_time = ''
  createForm.end_time = ''
  createForm.valid_date = []
  showSettingModal.value = false
  selectedUserIds.value = []
  showUserPanel.value = false
}

function onDeleteSetting (record : any) {
  delectUserDeviceRelation(record.id).then(res => {
    if (res && res.code === 0) {
      message.info('删除成功')
      fetchSettingData()
    }
  })
}

function onDeleteSetting2 (record : any) {
  delectUserDeviceRelation(record.id).then(res => {
    if (res && res.code === 0) {
      message.info('删除成功')
      fetchSettingData2()
    }
  })
}

const userDeviceRelationWorkspace = ref('')
const userDeviceRelationWorkspaceDataList = ref<any[]>([])
async function getUserDeviceRelationWorkspace () {
  const res = await userDeviceRelationWorkspaceList(device.value.device_sn)
  if (res && res.code === 0) {
    userDeviceRelationWorkspaceDataList.value = Array.isArray(res.data) ? res.data : []
  }
}

function resetSearch () {
  dataTime.value = []
  alarmLevel.value = null
  fetchData(true)
}

function resetSettingSearch () {
  authStatus.value = ''
  userDeviceRelationWorkspace.value = ''
  searchName.value = ''
  fetchSettingData()
}

const showUserPanel = ref(false)
const userList = ref<any[]>([])
const selectedUserIds = ref<string[]>([])
const body: IPage = {
  page: 1,
  total: 0,
  page_size: 100
}

function createUserPanel () {
  showUserPanel.value = !showUserPanel.value
  getAllUsersInfo(workspaceId, body).then(res => {
    if (res && res.code === 0) {
      userList.value = res.data.list
    }
  })
}

function handleUserPanelChange (val: string[]) {
  const names = userList.value
    .filter(u => val.includes(u.user_id))
    .map(u => u.username)
  createForm.user_names = names.join(', ')
  createForm.user_ids = val
}

// 计算面板定位样式
const userPanelStyle = computed(() => ({
  position: 'fixed',
  top: '30%',
  left: 'calc(50% + 300px + 4px)', // 600px/2+24px间距
  transform: 'translateY(-50%)',
  width: '320px',
  background: '#fff',
  padding: '24px 16px',
  boxShadow: '-2px 0 4px rgba(0,0,0,0.06)',
  zIndex: 2000,
  borderRadius: '4px',
  minHeight: '300px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  justifyContent: 'flex-start',
}))

const modalVisible = ref(false)
const deviceInfo = computed(() => store.state.deviceState.deviceInfo)
const dockInfo = computed(() => store.state.deviceState.dockInfo)

const showDevice = async (record : any) => {
  // console.log('执行showDevice前', modalVisible.value)
  console.log('执行showDevice前', record.children[0].device_sn)
  device.value = record
  modalVisible.value = true
  props.sn = record.device_sn
  props.childSn = record.children[0].device_sn
  props.deviceInfo.device = deviceInfo.value[record.children[0].device_sn]
  props.deviceInfo.dock = dockInfo.value[record.device_sn]
}

interface DeviceData {
  device: Device[]
}

const loading = ref(true)
const deleteTip = ref<boolean>(false)
const deleteSn = ref<string>()
const columns: ColumnProps[] = [
  { title: '设备名称', dataIndex: 'device_name', width: 90, className: 'titleStyle' },
  { title: '设备SN', dataIndex: 'device_sn', key: 'device_sn', width: 90, className: 'titleStyle', ellipsis: true },
  {
    title: '自定义名称',
    dataIndex: 'nickname',
    key: 'nickname',
    width: 100,
    sorter: (a: Device, b: Device) => a.nickname.localeCompare(b.nickname),
    className: 'titleStyle',
    ellipsis: true
  },
  { title: '固件版本号', dataIndex: 'firmware_version', key: 'firmware_version', width: 80, className: 'titleStyle' },
  { title: '状态', dataIndex: 'status', key: 'status', width: 60, className: 'titleStyle' },
  { title: '使用状态', dataIndex: 'use_status', key: 'use_status', width: 60, className: 'titleStyle' },
  {
    title: '工作空间名称',
    dataIndex: 'workspace_name',
    key: 'workspace',
    width: 100,
    className: 'titleStyle',
    ellipsis: true,
    customCell: (params) => {
      // 添加防御性检查，确保params不为undefined
      if (!params) {
        return { children: '', props: {} }
      }
      const { text, record, index } = params
      const obj = {
        children: text,
        props: {} as any,
      }
      if (current.value.indexOf(EDeviceTypeName.Dock) !== -1) {
        if (record && record.domain === EDeviceTypeName.Aircraft) {
          obj.children = ''
        }
      }
      return obj
    }
  },
  { title: '设备厂商', dataIndex: 'manufacturer', key: 'manufacturer', width: 80, align: 'center' },
  { title: '加入时间', dataIndex: 'bound_time', width: 130, sorter: (a: Device, b: Device) => a.bound_time.localeCompare(b.bound_time), className: 'titleStyle' },
  { title: '离线时间', dataIndex: 'login_time', width: 130, sorter: (a: Device, b: Device) => a.login_time.localeCompare(b.login_time), className: 'titleStyle' },
  { title: '操作', dataIndex: 'actions', key: 'actions', width: 140, className: 'titleStyle' },
]

const expandIcon = (props: any) => {
  if (judgeCurrentType(EDeviceTypeName.Dock) && !props.expanded) {
    return h('div',
      {
        style: 'border-left: 2px solid rgb(200,200,200); border-bottom: 2px solid rgb(200,200,200); height: 16px; width: 16px; float: left;',
        class: 'mt-5 ml0',
      })
  }
}

const rowClassName = (record: any, index: number) => {
  const className = []
  if ((index & 1) === 0) {
    className.push('table-striped')
  }
  if (record.domain !== EDeviceTypeName.Dock) {
    className.push('child-row')
  }
  return className.toString().replaceAll(',', ' ')
}

const expandRows = ref<string[]>([])
const data = reactive<DeviceData>({
  device: []
})

const paginationProp = reactive({
  pageSizeOptions: ['20', '50', '100'],
  showQuickJumper: true,
  showSizeChanger: true,
  pageSize: 50,
  current: 1,
  total: 0
})

// 获取分页信息
function getPaginationBody () {
  return {
    page: paginationProp.current,
    page_size: paginationProp.pageSize
  } as IPage
}

const rowSelection = {
  onChange: (selectedRowKeys: (string | number)[], selectedRows: []) => {
    console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows)
  },
  onSelect: (record: any, selected: boolean, selectedRows: []) => {
    console.log(record, selected, selectedRows)
  },
  onSelectAll: (selected: boolean, selectedRows: [], changeRows: []) => {
    console.log(selected, selectedRows, changeRows)
  },
  getCheckboxProps: (record: any) => ({
    disabled: judgeCurrentType(EDeviceTypeName.Dock) && record.domain !== EDeviceTypeName.Dock,
    style: judgeCurrentType(EDeviceTypeName.Dock) && record.domain !== EDeviceTypeName.Dock ? 'display: none' : ''
  }),
}
type Pagination = TableState['pagination']

const workspaceId: string = localStorage.getItem(ELocalStorageKey.WorkspaceId) || ''
const editableData: UnwrapRef<Record<string, Device>> = reactive({})
const current = ref([EDeviceTypeName.Dock]) //* EDeviceTypeName.Aircraft

function judgeCurrentType (type: EDeviceTypeName): boolean {
  return current.value.indexOf(type) !== -1
}

// 设备升级
const {
  deviceFirmwareUpgradeModalVisible,
  selectedDevice,
  onDeviceUpgrade,
  onUpgradeDeviceOk
} = useDeviceFirmwareUpgrade(workspaceId)

function onDeviceUpgradeWs (payload: DeviceCmdExecuteInfo) {
  updateDevicesByWs(data.device, payload)
}

function updateDevicesByWs (devices: Device[], payload: DeviceCmdExecuteInfo) {
  if (!devices || devices.length <= 0) {
    return
  }
  for (let i = 0; i < devices.length; i++) {
    if (devices[i].device_sn === payload.sn) {
      if (!payload.output) return
      const { status, progress, ext } = payload.output
      if (status === DeviceCmdExecuteStatus.Sent || status === DeviceCmdExecuteStatus.InProgress) { // 升级中
        const rate = ext?.rate ? (ext.rate / 1024).toFixed(2) + 'kb/s' : ''
        devices[i].firmware_status = DeviceFirmwareStatusEnum.DuringUpgrade
        devices[i].firmware_progress = (progress?.percent || 0) + '% ' + rate
      } else { // 终态：成功，失败，超时
        if (status === DeviceCmdExecuteStatus.Failed || status === DeviceCmdExecuteStatus.Timeout) {
          notification.error({
            message: `(${payload.sn}) Upgrade failed`,
            description: `Error Code: ${payload.result}`,
            duration: null
          })
        }
        // 拉取列表
        getDevices(current.value[0], true)
      }
      return
    }
    if (devices[i].children) {
      updateDevicesByWs(devices[i].children || [], payload)
    }
  }
}

useDeviceUpgradeEvent(onDeviceUpgradeWs)

// 获取设备列表信息
function getDevices (domain: number, closeLoading?: boolean) {
  if (!auth.hasPermi(['devices:aircraft', 'devices:dock'])) return
  if (!closeLoading) {
    loading.value = true
  }
  getBindingDevices(workspaceId, getPaginationBody(), domain).then(res => {
    if (res.code !== 0) {
      return
    }
    const resData: Device[] = res.data.list
    expandRows.value = []
    resData.forEach((val: any) => {
      if (val.children) {
        val.children = [val.children]
      }
      if (judgeCurrentType(EDeviceTypeName.Dock)) {
        expandRows.value.push(val.device_sn)
      }
    })
    data.device = resData
    paginationProp.total = res.data.pagination.total
    paginationProp.current = res.data.pagination.page
    paginationProp.pageSize = res.data.pagination.page_size
    loading.value = false
  })
}

function refreshData (page: Pagination) {
  paginationProp.current = page?.current!
  paginationProp.pageSize = page?.pageSize!
  getDevices(current.value[0])
}

// 编辑
function edit (record: Device) {
  // editableData[record.device_sn] = record
  editableData[record.device_sn] = { ...record }
}

// 保存
function save (record: Device) {
  delete editableData[record.device_sn]
  updateDevice({ nickname: record.nickname }, workspaceId, record.device_sn)
}

// 删除
function showDeleteTip (sn: any) {
  deleteTip.value = true
}

// 解绑
function unbind () {
  deleteTip.value = false
  unbindDevice(deleteSn.value?.toString()!).then(res => {
    if (res.code !== 0) {
      return
    }
    getDevices(current.value[0])
  })
}

// 选择设备
function select (item: any) {
  current.value = [item.key] // 更新current数组
  getDevices(current.value[0]) // 从数组中获取第一个元素作为参数
}

const currentDevice = ref({} as Device)
// 设备日志
const deviceLogUploadRecordVisible = ref(false)
function showDeviceLogUploadRecord (dock: Device) {
  deviceLogUploadRecordVisible.value = true
  currentDevice.value = dock
}

// 健康状态
const hmsVisible = ref<boolean>(false)

function showHms (dock: Device) {
  hmsVisible.value = true
  currentDevice.value = dock
}

const checked = ref<boolean>(false)
const checked1 = ref<boolean>(false)

const open = ref<boolean>(false)

const showModal = () => {
  open.value = true
}

const handleOk = (e: MouseEvent) => {
  console.log(e)
  open.value = false
}
const selectedMode = ref('待命')
const value_fly = ref('12')

const authColumns = [
  { title: '授权时间', width: 100, dataIndex: 'create_time', key: 'create_time', align: 'center' },
  { title: '授权人', width: 80, dataIndex: 'create_user_name', key: 'create_user_name', align: 'center' },
  { title: '使用事由', width: 80, dataIndex: 'reason', key: 'reason', align: 'center' },
  { title: '期限', width: 50, dataIndex: 'term', key: 'term', align: 'center', customRender: ({ text }: any) => getAuthTermName(text) },
  { title: '授权有效期', width: 80, dataIndex: 'valid_date', key: 'valid_date', align: 'center', className: 'wrap-cell' },
  { title: '授权状态', width: 100, dataIndex: 'status', key: 'status', align: 'center', customRender: ({ text }: any) => getAuthStatusName(text) },
  { title: '备注', width: 80, dataIndex: 'remark', key: 'remark', align: 'center' },
  { title: '操作', width: 80, key: 'action', align: 'center' }
]

const statusMap: Record<string, { label: string; color: string; chain: string }> = {
  IN_EFFECT: {
    label: '生效中',
    color: '#4caf50',
    chain: 'IN_EFFECT'
  },
  PENDING_EFFECTIVENESS: {
    label: '待生效',
    color: '#1890ff',
    chain: 'PENDING_EFFECTIVENESS'
  },
  REMOVED: {
    label: '已失效',
    color: '#888',
    chain: 'REMOVED'
  },
  EXPIRED: {
    label: '已过期',
    color: '#f5222d',
    chain: 'EXPIRED'
  }
}

function getStatusConfig (status: string): { label: string; color: string; chain: string } {
  return statusMap[status] || {
    label: status,
    color: '#888',
    chain: 'EXPIRED'
  }
}

const initCmdList = baseCmdList.map(cmdItem => Object.assign({}, cmdItem))
const cmdList = ref(initCmdList)

// 手动控制指令方法
const props = reactive({
  sn: '',
  childSn: '',
  deviceInfo: {} as DeviceInfoType,
})

watch(() => store.state.deviceState, data => {
  // console.log('deviceState', data)
  if (data.currentType === EDeviceTypeName.Aircraft && data.deviceInfo[props.childSn]) {
    props.deviceInfo.device = data.deviceInfo[props.childSn]
  }
  if (data.currentType === EDeviceTypeName.Dock && data.dockInfo[props.sn]) {
    props.deviceInfo.dock = data.dockInfo[props.sn]
    props.deviceInfo.device = data.deviceInfo[props.childSn]
  }
}, {
  deep: true
})

const {
  sendDockControlCmd,
  dockDebugOnOff
} = useDockControl()

async function openDockDebug () {
  const success = await dockDebugOnOff(props.sn, checked.value)
  if (success) {
    // updateDeviceSingleCmdInfo(cmdList.value[index])
  } else {
    checked.value = false
  }
}

async function sendControlCmd (cmdItem: DeviceCmdItem, index: number) {
  const success = await sendDockControlCmd({
    sn: props.sn,
    cmd: cmdItem.cmdKey,
    action: cmdItem.action
  }, true)
  if (success) {
    // updateDeviceSingleCmdInfo(cmdList.value[index])
  }
}

// 更新设备属性
const {
  genDevicePropsBySettingKey,
  setDeviceProps,
} = useDeviceSetting()

const deviceSetting = ref(cloneDeep(initDeviceSetting))
const deviceSettingFormModelFromOsd = ref(cloneDeep(initDeviceSettingFormModel))
const deviceSettingFormModel = ref(cloneDeep(initDeviceSettingFormModel)) // 真实使用的formModel

// 根据设备osd信息更新信息
watch(() => props.deviceInfo, (value) => {
  updateDeviceSettingInfoByOsd(deviceSetting.value, value)
  updateDeviceSettingFormModelByOsd(deviceSettingFormModelFromOsd.value, value)
  // console.log('deviceInfo', value)
}, {
  immediate: true,
  deep: true
})

function onShowPopConfirm (settingKey: DeviceSettingKeyEnum) {
  deviceSetting.value[settingKey].popConfirm.visible = true
  deviceSettingFormModel.value = cloneDeep(deviceSettingFormModelFromOsd.value)
}

function onCancel (settingKey: DeviceSettingKeyEnum) {
  deviceSetting.value[settingKey].popConfirm.visible = false
}

async function onConfirm (settingKey: DeviceSettingKeyEnum) {
  deviceSetting.value[settingKey].popConfirm.loading = true
  const body = genDevicePropsBySettingKey(settingKey, deviceSettingFormModel.value)
  await setDeviceProps(props.sn, body)
  deviceSetting.value[settingKey].popConfirm.loading = false
  deviceSetting.value[settingKey].popConfirm.visible = false
}

// 进入飞控
const pilotData = ref([])
const panelChoseVisible = ref(false)
const isSelectPilot = ref(false)
const selectedPilotId = ref(null)
const currentDevices = ref<OnlineDevice | null>(null)
const panelChoseName = ref('进入驾驶舱（请先选择驾驶舱）')

// 根据ID获取选中的飞手对象
const selectedPilot = computed(() =>
  pilotData.value.find(p => p.user_id === selectedPilotId.value)
)

const selectedPilotUsername = computed(() => selectedPilot.value?.username || '')

const openChosePanel = (device: any) => {
  currentDevices.value = device

  getUserDronePilotsByDepartment().then((res) => {
    if (!res.data) {
      message.warning('获取飞手数据失败')
      return
    }

    // 过滤出审核通过的飞手
    const approvedPilots = res.data.filter((pilot: any) =>
      pilot.qualifications?.some((q: any) => q.review_status === 'approved')
    )

    if (approvedPilots.length === 0) {
      // 检查是否存在已填写资质的飞手（qualifications 不为空数组）
      const hasAnyQualification = res.data.some((pilot: any) =>
        pilot.qualifications && pilot.qualifications.length > 0
      )
      if (hasAnyQualification) {
        message.warning('资质未审核，请联系管理员！')
      } else {
        message.warning('请添加飞手资质！')
      }
      panelChoseVisible.value = false
      return
    }

    // 有可用的飞手，显示选择弹窗
    pilotData.value = approvedPilots
    selectedPilotId.value = approvedPilots[0].user_id
    panelChoseVisible.value = true
    panelChoseName.value = '进入驾驶舱（请先选择飞手）'
  })
}

function openFlyControlPanel (record: any, version: string = 'v1') {
  if (!selectedPilotId.value || !selectedPilotUsername.value) {
    message.warning('请先选择飞手')
    return
  }

  const fromRoute = router.currentRoute.value.name
  const params = {
    sn: record.device_sn
  }

  sessionStorage.setItem('pilotUsername', selectedPilotUsername.value)
  sessionStorage.setItem('pilotId', String(selectedPilotId.value))
  sessionStorage.setItem('controllerSourceRoute', fromRoute as string)

  if (version === 'v1') {
    router.push({ name: 'flyController', params: params })
  } else {
    router.push({ name: 'droneController', params: params })
  }
}

const deviceCodeVisible = ref(false)
const codeMessage = ref([])
const openDeviceCode = async () => {
  const res = await getMqttBindingCode(workspaceId)
  if (res.code === 0) {
    codeMessage.value = res.data
    deviceCodeVisible.value = true
  }
}

onMounted(() => {
  getDevices(current.value[0])
  getAuthStatus()
  getAuthTerm()
})
</script>

<style lang="scss" scoped>
.device-table-wrap {
  .editable-row-operations {
    div>span {
      margin-right: 10px;
    }
  }
}

.project-app-wrapper {
  display: flex;
  transition: width 0.2s ease;
  height: 100%;
  width: 100%;

  .left {
    display: flex;
    width: 0px;
    flex: 0 0 82px;
    background-color: #232323;

    .main-content {
      flex: 1;
      color: $text-white-basic;
      width: 0px;
    }
  }
}
</style>

<style lang="scss" scoped>
:deep(.ant-table-body) {
  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 transparent;
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #d9d9d9;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
}

.device-content {
  height: 40px;
  width: 100%;
}

.table {
  background-color: white;
  margin: 20px;
  padding: 20px;
  height: 85vh;
}

.table-striped {
  background-color: #f7f9fa;
}

.ant-table {
  border-top: 1px solid rgb(0, 0, 0, 0.06);
  border-bottom: 1px solid rgb(0, 0, 0, 0.06);
}

.ant-table-tbody tr td {
  border: 0;
}

.ant-table td {
  white-space: nowrap;
}

.ant-table-thead tr th {
  background: white !important;
  border: 0;
}

th.ant-table-selection-column {
  background-color: white !important;
}

.ant-table-header {
  background-color: white !important;
}

.child-row {
  height: 70px;
}

.notice {
  background: $success;
  overflow: hidden;
  cursor: pointer;
}

.caution {
  background: orange;
  cursor: pointer;
  overflow: hidden;
}

.warn {
  background: red;
  cursor: pointer;
  overflow: hidden;
}

.sn-input {
  margin: -5px 0;
}

.sn-input.ant-input {
  background-color: #fff !important;
  color: black;
}

.sn-input.ant-input:hover {
  background-color: #fff !important;
  color: black;
}

.ant-picker {
  background-color: #fff;
  /* 设置默认背景颜色为白色 */
}

.ant-picker-focused {
  background-color: #fff;
  /* 设置获取焦点时（填写时）的背景颜色为白色 */
}

.ant-calendar-picker-input {
  background-color: #ffffff !important;
}

.ala-drawer-title {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
}

.ala-select {
  width: 150px;
  margin-right: 15px;
}

.org-table .even-row {
  background-color: rgb(238, 236, 236);
}

.org-table .odd-row {
  background-color: #fafafa;
}

.airport-oper {
  margin-left: 20px;
}

.airport-control {
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 500px;
  margin-bottom: 15px;
}

.air-con {
  background-color: #e2e2e2;
  opacity: 0.8;
  width: 300px;
  height: 50px;
  margin-right: 10px;
}

.air-icon {
  margin: 14px 0px 0px 8px;
  font-size: 23px;
  color: #46a6ff;
}

.drone-control {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 10px;
}

.dro-con {
  background-color: #e2e2e2;
  opacity: 0.8;
  width: 200px;
  height: 35px;
  margin-top: 6px;
  margin-right: 10px;
  padding: 6px 8px 0px 8px;
  font-size: 15px;
  font-weight: 600;
}
.list-search {
    width: 220px;
    margin-left: 20px;
  }
.auth-detail-header {
  background: #fff;
  padding: 24px 32px 18px 32px;
  border-radius: 12px;
  margin-bottom: 18px;
}
.auth-detail-header-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.auth-detail-user {
  display: flex;
  align-items: center;
  min-width: 180px;
  position: relative;
}
.auth-detail-user-label {
  position: absolute;
  left: 0;
  top: -28px;
  font-size: 14px;
  color: #888;
  font-weight: 500;
  letter-spacing: 1px;
}
.auth-detail-user-icon {
  margin-left: 4px;
  width: 80px;
  height: 80px;
  margin-right: 12px;
}
.auth-detail-user-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.auth-detail-username {
  font-size: 18px;
  font-weight: bold;
  color: #222;
}
.auth-detail-workspace {
  color: #666;
  font-size: 14px;
  margin-top: 4px;
}
.auth-detail-status-center-vertical-force {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 150px;
  min-width: 150px;
  max-width: 180px;
  margin: 0 10px;
  padding: 18px 0 12px 0;
  box-sizing: border-box;
}
.auth-detail-status-green-text {
  font-size: 22px;
  color: #4caf50;
  font-weight: bold;
  margin-bottom: 4px;
}
.auth-detail-status-link {
  display: block;
  margin-bottom: 8px;
}
.auth-detail-status-time {
  color: #222;
  font-size: 15px;
  margin-top: 2px;
  text-align: center;
}
.auth-detail-device-horizontal {
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 200px;
  position: relative;
}
.auth-detail-device-label {
  position: absolute;
  left: 0;
  top: -28px;
  font-size: 14px;
  color: #888;
  font-weight: 500;
  letter-spacing: 1px;
}
.auth-detail-device-icon {
  width: 80px;
  height: 80px;
  margin-bottom: 0;
  margin-right: 10px;
}
.auth-detail-device-info-vertical {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.auth-detail-device-name {
  color: #222;
  font-size: 15px;
  font-weight: bold;
}
.auth-detail-device-type,
.auth-detail-device-sn {
  color: #666;
  font-size: 13px;
}
.auth-detail-history {
  background: #f5f5f5;
  padding: 18px 24px 12px 24px;
  border-radius: 8px;
}
.auth-detail-history-title {
  font-size: 16px;
  font-weight: bold;
  color: #222;
  margin-bottom: 12px;
}
.auth-detail-table {
  background: #f5f5f5;
  color: #222;
}
:deep(.auth-detail-table .ant-table) {
  background: #f5f5f5 !important;
  color: #222 !important;
}
:deep(.auth-detail-table .ant-table-thead > tr > th) {
  background: #f5f5f5 !important;
  color: #222 !important;
}
:deep(.auth-detail-table .ant-table-tbody > tr > td) {
  background: #f5f5f5 !important;
  color: #222 !important;
}
.auth-detail-field {
  margin-bottom: 4px;
  display: flex;
  align-items: center;
}
.auth-detail-label {
  color: #888;
  font-size: 13px;
  min-width: 70px;
  font-weight: 500;
}
.auth-detail-value {
  color: #222;
  font-size: 14px;
  font-weight: 400;
}
:deep(.auth-detail-table .ant-table-cell) {
  white-space: normal !important;
  word-break: break-all;
  line-height: 1.5;
}
.ant-calendar-range-picker-separator{
  background-color: #ffffff !important;
  color: #aaaaaa !important;
}

.clickable-message {
  color: #1890ff; /* 蓝色 */
  cursor: pointer;
  text-decoration: underline;
  transition: color 0.2s;
}

.clickable-message:hover {
  color: #096dd9; /*  hover时颜色加深 */
}

.json-container {
  max-height: 500px;
  overflow: auto;
  background-color: #f5f5f5;
  border-radius: 4px;
  padding: 16px;
  margin-top: 10px;
}

pre {
  margin: 0;
  font-family: Consolas, Monaco, monospace;
  white-space: pre-wrap;
  color: #333;
}

.copy-icon {
  color: #1890ff;
  font-size: 20px;
  margin-left: 97%;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
  background-color: rgba(0, 0, 0, 0.02);
  border-radius: 4px;
}

.loading-spinner {
  text-align: center;
}

.loading-text {
  margin-top: 12px;
  color: #999;
  font-size: 14px;
}

.sensor-message-modal {
  :deep(.ant-modal-content) {
    border-radius: 12px;
    overflow: hidden;
  }

  :deep(.ant-modal-header) {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    padding: 20px 24px;
    border-bottom: none;

    .ant-modal-title {
      color: white;
      font-size: 18px;
      font-weight: 600;
    }
  }

  :deep(.ant-modal-close) {
    color: white;

    &:hover {
      color: rgba(255, 255, 255, 0.8);
    }
  }

  :deep(.ant-modal-body) {
    padding: 0;
    max-height: 30vh;
    overflow-y: auto;
  }
}

.detail-content {
  // padding: 20px;
  background: linear-gradient(180deg, #f8f9fa 0%, #ffffff 100%);
  height: 700px;
  overflow-y: auto;
}

.detail-card {
  margin-bottom: 10px;
  border: 1px solid #e8e8e8;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  }

  :deep(.ant-card-head) {
    background: #fafafa;
    border-bottom: 1px solid #e8e8e8;
    border-radius: 10px 10px 0 0;
    padding: 0px 20px;
  }

  .card-header {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #1890ff;
    font-weight: 600;

    i {
      font-size: 18px;
    }

    .ml8 {
      margin-left: 8px;
    }

    .action-buttons {
      margin-left: auto;
      display: flex;
      gap: 8px;

      .toggle-btn,
      .copy-btn {
        color: #666;
        font-size: 14px;

        &:hover {
          color: #1890ff;
          background: rgba(24, 144, 255, 0.1);
        }
      }
    }
  }

  :deep(.ant-descriptions) {
    .ant-descriptions-item-label {
      background: #fafafa;
      font-weight: 600;
      color: #666;
      width: 120px;
    }

    .ant-descriptions-item-content {
      color: #333;
      font-weight: 500;
    }
  }
}

.device-info {
  // font-family: 'Courier New', monospace;
  color: #1890ff;
  font-weight: 600;
}

.message-content {
  background: white;
  border-radius: 8px;

  .data-info {
    padding: 12px 16px;
    background: #f8f9fa;
    border-bottom: 1px solid #e8e8e8;

    .data-count {
      color: #666;
      font-size: 14px;
    }
  }

  .message-table {
    :deep(.ant-table-thead > tr > th) {
      background: #fafafa;
      font-weight: 600;
      color: #666;
      border-bottom: 2px solid #e8e8e8;
    }

    :deep(.ant-table-tbody > tr > td) {
      border-bottom: 1px solid #f0f0f0;
    }

    :deep(.ant-table-tbody > tr:hover > td) {
      background: #f5f7fa;
    }

    .row-index {
      color: #999;
      font-weight: 500;
    }
  }

  .json-section {
    .json-content {
      // background: #1e1e1e;
      border-radius: 6px;
      padding: 16px;
      max-height: 400px;
      overflow: auto;
    }

    .json-pretty {
      margin: 0;
      // color: #d4d4d4;
      // font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
      font-size: 13px;
      line-height: 1.5;
    }
  }

  .parse-error {
    .raw-message {
      background: #fff8e6;
      border: 1px solid #ffd591;
      border-radius: 6px;
      padding: 12px;
      margin-top: 12px;

      pre {
        margin: 0;
        white-space: pre-wrap;
        word-break: break-all;
        color: #d46b08;
      }
    }
  }

  .empty-data,
  .empty-message {
    padding: 40px 0;
    text-align: center;
  }
}

.pilot-selector {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.pilot-radio-group {
  display: flex;
  flex-wrap: wrap;
}

.pilot-radio-group .ant-radio-button-wrapper {
  width: calc(25% - 8px); /* 四等分，减去 gap 的间距 */
  margin-right: 0;        /* 取消默认右边距 */
  text-align: center;     /* 文字居中（可选） */
  overflow: hidden;       /* 防止内容过长溢出 */
  text-overflow: ellipsis;
  white-space: nowrap;
}

.button-group {
  display: flex;
  justify-content: center;
  gap: 8px;
}

.bind-code-content {
  .bind-info-row {
    display: flex;
    align-items: flex-start;
    margin-bottom: 16px;
    line-height: 1.5;

    .bind-label {
      width: 120px;
      flex-shrink: 0;
      color: #5c5f66;
      font-weight: 500;
      letter-spacing: 0.3px;
    }

    .bind-value {
      flex: 1;
      color: #1f2f3d;
      word-break: break-all;
      background: #f5f7fa;
      padding: 6px 12px;
      border-radius: 6px;
      font-size: 13px;

      &.bind-code {
        background: #e6f7ff;
        color: #1890ff;
        font-weight: 600;
        letter-spacing: 1px;
      }
    }
  }
}
</style>
